<template>
  <div>
    <v-snackbar :top="true" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-snackbar :top="y === 'top'" v-model="errorSnackbar">
      {{text}}
      <v-btn color="red" class="white--text" flat @click="errorSnackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat color="white">
      <v-chip v-if="serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&serviceAccount.isSuspended&&serviceAccount.isActive" class="white--text" color="orange">Suspended</v-chip>
      <v-chip v-else-if="serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&(new Date(serviceAccount.fnoDeactivationDate)>new Date()||serviceAccount.fnoDeactivationDate==null)" class="white--text" color="light-green">Active</v-chip>
      <v-chip v-else-if="serviceAccount.fnoActivationDate!==null&&serviceAccount.fnoDeactivationDate!=null&&(new Date(serviceAccount.fnoDeactivationDate)<new Date())" class="white--text" color="red">Inactive</v-chip>
      <v-chip v-else-if="serviceAccount.fnoActivationDate==null||new Date(serviceAccount.fnoActivationDate)>new Date()" class="white--text" color="blue">Pending</v-chip>
      
      
      <h2
        class="dark-grey--text px-2"
        v-if="serviceAccount"
      >Service Account: {{serviceAccount.circuitNumber}}</h2>
      <v-spacer></v-spacer>
      <div v-if="serviceAccount&&serviceAccount.device&&serviceAccount.deviceBridgeId&&serviceAccount.device.isU2000">
        <v-btn @click="suspendServices(serviceAccount)" round class="white--text" color="red" v-if="allOpenTickets.filter(x=>x.ticketCategoryItem.name === 'U2000: Deactivate Service').length==0&&serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&(new Date(serviceAccount.fnoDeactivationDate)>new Date()||serviceAccount.fnoDeactivationDate==null)&&!serviceAccount.isSuspended">Suspend</v-btn>
      <v-btn @click="reactivateServices(serviceAccount)" round class="white--text" color="light-green" v-else-if="allOpenTickets.filter(x=>x.ticketCategoryItem.name === 'U2000: Activate Service').length==0&&serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&serviceAccount.isSuspended&&serviceAccount.isActive">Reactivate</v-btn>
<!-- <v-chip v-else-if="serviceAccount.fnoActivationDate!==null&&serviceAccount.fnoDeactivationDate!=null&&(new Date(serviceAccount.fnoDeactivationDate)<new Date())" class="white--text" color="red">Inactive</v-chip> -->
      </div>
      
    </v-toolbar>
    <v-divider></v-divider>
    <v-card flat>
        <v-layout wrap>
          <v-flex xs12 sm5 md5 mb-1>
            <v-card class="rounded-card">
              <v-card-text>
                <h2 class="dark-grey--text">Account Summary</h2>
                <!-- <v-btn @click="findSimilarContacts('Mark')">Similar Xero Contacts</v-btn> -->
                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 text-xs-left>
                      <v-layout justify-center v-if="serviceAccount.circuitNumber">
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Circuit Number:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                          >{{serviceAccount.circuitNumber}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="serviceAccount.location">
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Location:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                          >{{serviceAccount.location.locationDescription}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="serviceAccount.initialActivation">
                        <v-flex xs6>
                          <h2
                            class="subheading grey--text font-weight-bold"
                          >Initial Activation Date:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light">
                            <v-chip
                              small
                              color="primary"
                              class="white--text font-weight-bold"
                            >{{formatDate(serviceAccount.initialActivation)}}</v-chip>
                          </h3>
                        </v-flex>
                      </v-layout>

                      <!-- <v-layout justify-left>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Last Update:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light">
                            <v-chip
                              small
                              color="primary"
                              class="white--text font-weight-bold"
                            >{{formatDate(serviceAccount.createdAt)}}</v-chip>
                          </h3>
                        </v-flex>
                      </v-layout> -->

                      <v-layout justify-center>
                        <v-flex xs6>
                          <h2
                            class="subheading grey--text font-weight-bold"
                          >Internet Service Provider:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <!-- <v-avatar> -->
                          <v-img contain max-height="70px" :src="serviceAccount.customerOrganisation.logo" />
                          <!-- </v-avatar> -->
                        </v-flex>
                      </v-layout>

                      <v-layout justify-center wrap>
                         <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">FNO Package:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                            v-if="serviceAccount.packagesIsp.packagesFno"
                          >{{serviceAccount.packagesIsp.packagesFno.packageCode}}</h3>
                          <v-icon color="red" v-else>not_interested</v-icon>
                        </v-flex>
                         <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">FNO Package Price:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                            v-if="serviceAccount.packagesIsp.packagesFno"
                          >{{serviceAccount.packagesIsp.packagesFno.packageBasePrice |currency}}</h3>
                          <v-icon color="red" v-else>not_interested</v-icon>
                        </v-flex>
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Data Package:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                            v-if="serviceAccount.customerOrganisation"
                          >{{serviceAccount.customerOrganisation.name}} | {{serviceAccount.packagesIsp.name}}</h3>
                          <v-icon color="red" v-else>not_interested</v-icon>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="serviceAccount.packagesIspId!==null">
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Data Package Term:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                          >{{serviceAccount.packagesIsp.term}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="serviceAccount.packagesIspId!==null">
                        <v-flex xs6>
                          <h2
                            class="subheading grey--text font-weight-bold"
                          >Data Package Monthly Fee:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                          >{{serviceAccount.ispRecurringPriceVatInc|currency}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="serviceAccount.pppoeUsername">
                        <v-flex xs6>
                          <h2
                            class="subheading grey--text font-weight-bold"
                          >PPPoE Username:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                          >{{serviceAccount.pppoeUsername}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="serviceAccount.pppoePassword">
                        <v-flex xs6>
                          <h2
                            class="subheading grey--text font-weight-bold"
                          >PPPoE Password:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                          >{{serviceAccount.pppoePassword}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout v-if="serviceAccount.packagesIspId!==null">
                        <v-flex xs6>
                          <h2 class="subheading grey--text font-weight-bold">Speed Profile (Mbps):</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light">
                            <v-icon color="light-green">arrow_drop_down</v-icon>
                            {{serviceAccount.packagesIsp.packagesFno.speedProfile.downloadMbps}}
                            <v-icon color="red">arrow_drop_up</v-icon>
                            {{serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps}}
                          </h3>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

           <!-- Active Accounts -->
          <v-flex xs12 sm3 md3 mb-1 mx-1>
            <v-card class="rounded-card" height="420px">
              <v-card-text>
                <h2 class="dark-grey--text">Services</h2>
                <v-tabs grow>
                  <v-tab @click="showInternet = true, showWifi = false, showVoip = false">
                    <v-icon>language</v-icon>Internet
                  </v-tab>
                  <v-tab v-if="wifiServices.length>0" @click="showInternet = false, showWifi = true, showVoip = false" >
                    <v-icon>wifi</v-icon>Wifi
                  </v-tab>
                  <!-- <v-tab @click="showInternet = false, showWifi = false, showVoip = true" >
                    <v-icon>call</v-icon>VOIP
                  </v-tab> -->
                </v-tabs>

                <!-- Internet -->
                <v-container grid-list-xs v-if="showInternet">
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 v-for="internet in internetServices" :key="internet.id">
                      <v-card hover class="ma-2 pa-2" v-if="internetServices.length>0">
                        <v-tile>
                          <v-layout align-center  v-if="serviceAccount.device&&serviceAccount.device.isU2000">
                            <v-flex xs12>
                              <v-tile-title>
                                <h3 class="grey--text font-weight-light" >
                                  <b>Status:</b> <v-chip class="white--text" color="light-green" v-if="internet.isActive">Active</v-chip><v-chip class="white--text" color="red" v-else>Inactive</v-chip></h3>
                                <h3 v-if="internet.serverPortId" class="grey--text font-weight-light">
                                  {{internet.servicePortId}}
                                </h3>
                                <h3 class="grey--text font-weight-light" v-if="internet.gemportId">
                                  <b>GEM Port Type:</b> {{internet.gemportId}}</h3>
                                <h3 class="grey--text font-weight-light" v-if="internet.access_type">
                                  <b>Access Type:</b> {{internet.access_type}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="internet.access_type == 'PPPOE' ||internet.access_type=='PPPoE'">
                                  <b>PPPOE Username:</b> {{internet.pppoeUsername}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="internet.access_type == 'PPPOE' ||internet.access_type=='PPPoE'">
                                  <b>PPPOE Password:</b> {{internet.pppoePassword}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="internet.vlan">
                                  <b>Inner VLAN:</b> {{internet.vlan}}</h3>
                                   <h3 class="grey--text font-weight-light" v-if="internet.vlanXlate">
                                  <b>Outer VLAN:</b> {{internet.vlanXlate}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="internet.downstreamRate">
                                  <b>Download (Mbps):</b> {{internet.downstreamRate}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="internet.upstreamRate">
                                  <b>Upload (Mbps):</b> {{internet.upstreamRate}}</h3>
                              </v-tile-title>
                              <!-- <v-tile-subtitle>
                                <v-layout wrap justify-center align-center>
                                  <v-flex xs12>
                                    <h3 class="grey--text">Ethernet Ports</h3>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-layout justify-center>
                                      <v-chip class="white--text" color="light-green" v-if="internet.port_1">1</v-chip>
                                      <v-chip class="white--text" color="light-green" v-if="internet.port_2">2</v-chip>
                                      <v-chip class="white--text" color="light-green" v-if="internet.port_3">3</v-chip>
                                      <v-chip class="white--text" color="light-green" v-if="internet.port_4">4</v-chip>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-tile-subtitle> -->
                            </v-flex>
                          </v-layout>
                          <v-layout align-center  v-else-if="serviceAccount.device&&serviceAccount.device.deviceMakeModel.deviceMake.name.toLowerCase()=='zhone'">
                            <v-flex xs12>
                              <v-tile-title>
                                <h3 class="grey--text font-weight-light" v-if="internet.tpType">
                                  <b>TP Type:</b> {{tpTypeArray.find(x=>x.id == internet.tpType).name}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="internet.tpIndex">
                                  <b>Port:</b> {{internet.tpIndex}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="internet.rgMode">
                                  <b>RG Mode:</b> {{rgModeArray.find(x=>x.id == internet.rgMode).name}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="internet.vlanXlate">
                                  <b>Inner VLAN:</b> {{internet.vlanXlate}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="internet.vlan">
                                  <b>Outer VLAN:</b> {{internet.vlan}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="internet.egressGroupIndex">
                                  <b>Egress Group Index:</b> {{internet.egressGroupIndex}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="internet.groupIndex">
                                  <b>Ingress Group Index:</b> {{internet.groupIndex}}</h3>
                              </v-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-tile>
                      </v-card>
                    </v-flex>
                    <v-flex v-if="showInternet&&internetServices.length == 0">
                      <v-layout align-center justify-center>
                        <h3 class="grey--text font-weight-light">No Active Internet Services.</h3>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>

                <!-- Wifi -->

                <v-container grid-list-xs v-if="showWifi">
                  <v-layout wrap >
                    <v-card-text  style="overflow-y: auto; height:400px">
                       <v-flex xs12 sm12 md12 v-for="wifi in wifiServices" :key="wifi.id">
                      <v-card hover class="ma-1 pa-1">
                        <v-tile>
                          <v-layout align-center>
                            <v-flex xs12>
                              <v-tile-title>
                                <h3 class="grey--text font-weight-light" v-if="wifi.ssid">
                                  <b>SSID:</b> {{wifi.ssid}} <v-icon v-if="wifi.enable" color="light-green">check_circle</v-icon><v-icon v-else color="red">cancel</v-icon></h3>
                                  <h3 class="grey--text font-weight-light" v-if="wifi.password">
                                  <b>Password:</b> {{wifi.password}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="wifi.frequency">
                                  <b>Frequency:</b> {{wifi.frequency}}</h3>
                                  
                              </v-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-tile>
                      </v-card>
                    </v-flex>
                    </v-card-text>
                   
                    <v-flex xs12 v-if="showWifi&&wifiServices.length == 0">
                      <v-layout align-center justify-center>
                        <h3 class="grey--text font-weight-light">No Active Wifi Services.</h3>
                      </v-layout>
                    </v-flex>
                    <!-- <v-flex v-if="availableFrequency.length>0">
                      <v-btn round color="primary" class="white--text" @click="addWifiProfileModal()"><v-icon  color="white">add_circle_outline</v-icon> ADD</v-btn>
                    </v-flex> -->
                  </v-layout>
                </v-container>

                <!-- VOIP -->
                <v-container grid-list-xs v-if="showVoip">
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 v-for="voip in voipServices" :key="voip.id">
                      <v-card hover class="ma-2 pa-2">
                        <v-tile>
                          <v-layout align-center>
                            <v-flex xs8 text-xs-left>
                              <v-tile-title>
                                <h3 class="grey--text">{{voip.id}}</h3>
                              </v-tile-title>
                              <v-tile-subtitle></v-tile-subtitle>
                            </v-flex>
                          </v-layout>
                        </v-tile>
                      </v-card>
                    </v-flex>
                    <v-flex v-if="showVoip&&voipServices.length == 0">
                      <v-layout align-center justify-center>
                        <h3 class="grey--text font-weight-light">No Active VOIP Services.</h3>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs12 sm3 md3 mb-1>
            <v-card class="rounded-card" height="420px">
              <v-card-text>
                <h2 class="dark-grey--text">Tickets <v-icon
        flat
        depressed
        rounded
        @click="addTicket(newDay); ticketAssignedLog= [];ticketCommentLog= [];"
        color="primary"
        class="white--text"
      >add_circle_outline</v-icon></h2>
                <v-tabs grow>
                  <v-tab @click="showPendingTickets = true, showResolvedTickets = false">Pending</v-tab>
                  <v-tab @click="showPendingTickets = false, showResolvedTickets = true">Resolved</v-tab>
                </v-tabs>
                <v-container grid-list-xs v-if="showPendingTickets">
                  <v-layout wrap justify-center>
                    <v-flex xs12 sm12 md12 v-for="pending in pendingTickets" :key="pending.id">
                      <v-card hover >
                        <v-tile>
                          <v-layout align-center>
                            <v-flex >
                              <v-tile-title @click="routeToTicketSummary(pending.id)">
                                 <v-layout>
                            <v-flex xs6 text-xs-left>
                              <h4 class="mx-1 grey--text font-weight-bold">ID:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-left>
                               <h4 class=" grey--text font-weight-light">{{pending.id}}</h4>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center>
                            <v-flex xs6 text-xs-left>
                              <h4 class="mx-1  grey--text font-weight-bold">Category:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-left>
                              <h4
                                class="grey--text font-weight-light"
                              >{{pending.ticketCategoryItem.ticketCategory.name}}</h4>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center>
                            <v-flex xs6 text-xs-left>
                               <h4 class="mx-1 grey--text font-weight-bold">Subcategory:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-left>
                             <h4
                                class="grey--text font-weight-light"
                              >{{pending.ticketCategoryItem.name}}</h4>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center align-center>
                            <v-flex xs6 text-xs-left>
                               <h4 class="mx-1 grey--text font-weight-bold">Status:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-left>
                               <h4 class="grey--text">
                                <v-chip
                                  small
                                  :class="`${pending.currentStatus.replace(/\s/g,'').toLowerCase()} white--text`"
                                >{{pending.currentStatus}}</v-chip>
                              </h4>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center>
                            <v-flex xs6 text-xs-left>
                               <h4 class="mx-1 grey--text font-weight-bold">Assigned To:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-left>
                              <h4
                                 v-if="pending.assignedTo !==null"
                                class="grey--text font-weight-light"
                              >{{pending.assignedTo.name}} {{pending.assignedTo.surname}}</h4>
                              <h4 v-else class="grey--text font-weight-light">Unassigned</h4>
                            </v-flex>
                          </v-layout>
                              </v-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-tile>
                      </v-card>
                    </v-flex>

                    <v-flex v-if="showPendingTickets&&allOpenTickets.length == 0">
                      <v-layout align-center justify-center>
                        <h3 class="grey--text font-weight-light">No Pending Tickets.</h3>
                      </v-layout>
                    </v-flex>
                     <v-flex
                      xs12
                      class="card-actions text-xs-center"
                      v-if="showPendingTickets && allOpenTickets.length > 1"
                    >
                      <v-pagination
                        v-model="pendingTicketPage"
                        :length="Math.ceil(allOpenTickets.length)"
                        :total-visible="5"
                      ></v-pagination>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-container grid-list-xs v-if="showResolvedTickets">
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 v-for="resolved in resolvedTickets" :key="resolved.id">
                      <v-card hover >
                        <v-card-text>
                          <v-tile>
                            <v-layout align-center>
                              <v-flex >
                                <v-tile-title @click="routeToTicketSummary(resolved.id)">
                                 <v-layout>
                            <v-flex xs6 text-xs-left>
                              <h4 class="mx-1 grey--text font-weight-bold">ID:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-right>
                               <h4 class=" grey--text font-weight-light">{{resolved.id}}</h4>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center>
                            <v-flex xs6 text-xs-left>
                              <h4 class="mx-1  grey--text font-weight-bold">Category:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-right>
                              <h4
                                class="grey--text font-weight-light"
                              >{{resolved.ticketCategoryItem.ticketCategory.name}}</h4>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center>
                            <v-flex xs6 text-xs-left>
                               <h4 class="mx-1 grey--text font-weight-bold">Subcategory:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-right>
                             <h4
                                class="grey--text font-weight-light"
                              >{{resolved.ticketCategoryItem.name}}</h4>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center align-center>
                            <v-flex xs6 text-xs-left>
                               <h4 class="mx-1 grey--text font-weight-bold">Status:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-right>
                               <h4 class="grey--text">
                                <v-chip
                                  small
                                  :class="`${resolved.currentStatus.replace(/\s/g,'').toLowerCase()} white--text`"
                                >{{resolved.currentStatus}}</v-chip>
                              </h4>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center>
                            <v-flex xs6 text-xs-left>
                               <h4 class="mx-1 grey--text font-weight-bold">Assigned To:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-right>
                              <h4
                                 v-if="resolved.assignedTo !==null"
                                class="grey--text font-weight-light"
                              >{{resolved.assignedTo.name}} {{resolved.assignedTo.surname}}</h4>
                              <h4 v-else class="grey--text font-weight-light">Unassigned</h4>
                            </v-flex>
                          </v-layout>
                              </v-tile-title>
                                <v-tile-subtitle>                                
                                </v-tile-subtitle>
                              </v-flex>
                            </v-layout>
                          </v-tile>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex v-if="showResolvedTickets&&allResolvedTickets.length == 0">
                      <v-layout align-center justify-center>
                        <h3 class="grey--text font-weight-light">No Resolved Tickets.</h3>
                      </v-layout>
                    </v-flex>
                    <v-flex
                      xs12
                      class="card-actions"
                      v-if="showResolvedTickets && allResolvedTickets.length > 1"
                    >
                      <v-pagination
                        v-model="resolvedTicketPage"
                        :length="Math.ceil(allResolvedTickets.length)"
                        :total-visible="5"
                      ></v-pagination>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md3 mb-1 mx-1>
            <v-card class="rounded-card" >
              <v-card-text>
                <h2 class="dark-grey--text">Account History</h2>

                <v-container grid-list-xs>
                  <v-layout wrap justify-center>
                    <v-flex
                      xs12
                      sm12
                      md12
                      v-for="history in serviceAccountHistory"
                      :key="history.id"
                      text-xs-left
                    >
                      <v-card hover class="ma-2 pa-2">
                        <v-tile wrap>
                          <v-tile-title class="grey--text">{{history.packagesIsp.name}}</v-tile-title>
                          <v-spacer></v-spacer>
                          <v-tile-title class="grey--text">
                            <b>Service Account ID:</b>
                            {{history.id}}
                          </v-tile-title>
                          <v-spacer></v-spacer>
                          <v-tile-content class="grey--text" v-if="history.fnoActivationDate">
                            <v-chip
                              dense
                              color="light-green"
                              class="white--text font-weight-bold"
                            >{{formatDate(history.fnoActivationDate)}}</v-chip>-
                            <v-chip
                              dense
                              v-if="history.fnoDeactivationDate"
                              color="red"
                              class="white--text font-weight-bold"
                            >{{formatDate(history.fnoDeactivationDate)}}</v-chip>
                            <v-chip
                              v-else
                              color="blue"
                              dense
                              class="white--text font-weight-bold"
                            >Present</v-chip>
                          </v-tile-content>
                          <v-tile-content class="grey--text" v-else>
                            <v-chip
                              dense
                              color="blue"
                              class="white--text font-weight-bold"
                            >Pending Activation</v-chip>
                           
                          </v-tile-content>
                        </v-tile>
                      </v-card>
                    </v-flex>

                    <v-flex v-if="allServiceAccountHistory.length == 0">
                      <v-layout align-center justify-center>
                        <h3 class="grey--text font-weight-light">No Service Account History</h3>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 v-if="allServiceAccountHistory.length > 2" class="card-actions">
                      <v-pagination
                        v-model="serviceAccountHistoryPage"
                        :length="Math.ceil(allServiceAccountHistory.length/2)"
                        :total-visible="5"
                      ></v-pagination>
                    </v-flex>
                   
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <!-- Change Requests -->

          <v-flex xs12 sm3 md3 mb-1>
            <v-card class="rounded-card card-outter">
              <v-card-text>
                <h2 class="dark-grey--text">
                  Change Requests
                  <v-icon v-if="serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&(new Date(serviceAccount.fnoDeactivationDate)>new Date()||serviceAccount.fnoDeactivationDate==null)" color="primary" @click="changeRequestModal=true; noZhoneDeviceOnLocation=false; noAcsDeviceOnLocation=false;previousAccounts=false">add_circle_outline</v-icon>
                </h2>
                <v-tabs grow>
                  <v-tab @click="showPendingRequests = true, showResolvedRequests = false">Pending</v-tab>
                  <v-tab @click="showPendingRequests = false, showResolvedRequests = true">Resolved</v-tab>
                </v-tabs>
                <v-container grid-list-xs v-if="showPendingRequests">
                  <v-layout wrap justify-center>
                    <v-flex xs12 sm12 md12 v-for="pending in pendingRequests" :key="pending.id">
                      <v-card hover class="ma-2 pa-2">
                        <v-tile>
                          <v-layout align-center wrap>
                            <v-flex xs12>
                              <h3 class="grey--text">{{pending.requestType}} <v-chip color="blue" class="white--text">{{pending.status}}</v-chip></h3>
                            </v-flex>
                            <v-flex xs12>
                              <v-tile-title>
                                
                                <div
                                  v-if="(pending.requestType.includes('Upgrade')||pending.requestType.includes('Downgrade'))&&pending.fromSpeedProfile&&pending.toSpeedProfile"
                                >
                                  <h4 class="grey--text">
                                    From:
                                    <v-icon color="light-green">arrow_drop_down</v-icon>
                                    {{pending.fromSpeedProfile.downloadMbps}}
                                    <v-icon color="red">arrow_drop_up</v-icon>
                                    {{pending.fromSpeedProfile.uploadMbps}}
                                  </h4>
                                  <h4 class="grey--text">
                                    To:
                                    <v-icon color="light-green">arrow_drop_down</v-icon>
                                    {{pending.toSpeedProfile.downloadMbps}}
                                    <v-icon color="red">arrow_drop_up</v-icon>
                                    {{pending.toSpeedProfile.uploadMbps}}
                                  </h4>
                                </div>
                                <h4></h4>
                              </v-tile-title>
                              <v-tile-subtitle>
                                 <h4 class="grey--text font-weight-light">
                                 <b>Submitted:</b>  {{ formatDate(pending.createdAt) }}
                                </h4>
                                 <h4 class="grey--text font-weight-light">
                                 <b>Requested Date:</b>  {{ formatDate(pending.requestedChangeDate) }}
                                </h4>
                                <h4 class="grey--text font-weight-light" v-if="pending.migrationLocation">
                                 <b>Migrating to:</b> 
                                  {{pending.migrationLocation.locationDescription}}
                                </h4>
                              </v-tile-subtitle>
                            </v-flex>
                            <v-flex xs12 style="text-align:center">                         
                                <v-layout justify-center>
                                   <v-btn
                                      v-if="acceptingRequestChange"
                                      round
                                      disabled
                                    >
                                      <span>Accepting Request </span>
                                      <v-progress-circular
                                        size="20"
                                        indeterminate
                                        color="white"
                                      ></v-progress-circular
                                    ></v-btn> 
                                  <v-icon v-else-if="!denyingRequestChange" large color="light-green" @click="pending.requestType != 'Reactivation'? acceptRequestChange(pending):acceptReactivation(pending)">done</v-icon>
                                   <v-btn
                                      v-if="denyingRequestChange"
                                      round
                                      disabled
                                    >
                                      <span>Denying Request </span>
                                      <v-progress-circular
                                        size="20"
                                        indeterminate
                                        color="white"
                                      ></v-progress-circular
                                    ></v-btn>
                                  <v-icon v-else-if="!acceptingRequestChange" large color="red" @click="denyRequestItem(pending)">clear</v-icon>
                                </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-tile>
                      </v-card>
                    </v-flex>

                    <v-flex v-if="allPendingRequests.length == 0">
                      <v-layout align-center justify-center>
                        <h3 class="grey--text font-weight-light">No Pending Requests.</h3>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 class="card-actions" v-if="showPendingRequests && allPendingRequests.length > 1">
                      <v-pagination
                        v-model="pendingRequestPage"
                        :length="Math.ceil(allPendingRequests.length)"
                        :total-visible="5"
                      ></v-pagination>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-container grid-list-xs v-if="showResolvedRequests">
                  <v-layout wrap justify-center>
                    <v-flex xs12 sm12 md12 v-for="resolved in resolvedRequests" :key="resolved.id">
                      <v-card hover class="ma-2">
                        <v-card-text class="pa-2">
                          <v-tile>
                            <v-layout align-center>
                              <v-flex xs12 text-xs-left>
                                <v-tile-title>
                                  <h3 class="title grey--text text-xs-center">
                                    {{resolved.requestType}}
                                    <v-chip
                                      class="white--text"
                                      dense
                                      v-if="resolved.status=='Resolved'"
                                      color="light-green"
                                    >{{resolved.status}}</v-chip>
                                    <v-chip
                                      class="white--text"
                                      dense
                                      v-else
                                      color="red"
                                    >{{resolved.status}}</v-chip>
                                  </h3>

                                  <div
                                    v-if="(resolved.requestType.includes('Upgrade')||resolved.requestType.includes('Downgrade'))&&resolved.fromSpeedProfile&&resolved.toSpeedProfile"
                                  >
                                    <h4 class="grey--text font-weight-light">
                                      <b>From:</b>
                                      <v-icon color="light-green">arrow_drop_down</v-icon>
                                      {{resolved.fromSpeedProfile.downloadMbps}}
                                      <v-icon color="red">arrow_drop_up</v-icon>
                                      {{resolved.fromSpeedProfile.uploadMbps}}
                                    </h4>
                                    <h4 class="grey--text font-weight-light">
                                      <b>To:</b>
                                      <v-icon color="light-green">arrow_drop_down</v-icon>
                                      {{resolved.toSpeedProfile.downloadMbps}}
                                      <v-icon color="red">arrow_drop_up</v-icon>
                                      {{resolved.toSpeedProfile.uploadMbps}}
                                    </h4>
                                  </div>
                                </v-tile-title>
                                <v-tile-subtitle>
                                  <h4 class="grey--text font-weight-light">
                                    <b>Resolved Date:</b>
                                    {{formatDate(resolved.updatedAt)}}
                                  </h4>
                                  <h4 class="grey--text font-weight-light">
                                    <b>Resolved by:</b>
                                    {{resolved.fnoContactName}}
                                  </h4>
                                </v-tile-subtitle>
                              </v-flex>
                            </v-layout>
                          </v-tile>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 class="card-actions" v-if="showResolvedRequests && allResolvedRequests.length > 1">
                      <v-pagination
                        v-model="resolvedRequestPage"
                        :length="Math.ceil(allResolvedRequests.length)"
                        :total-visible="5"
                      ></v-pagination>
                    </v-flex>

                    <v-flex v-if="allResolvedRequests.length == 0">
                      <v-layout align-center justify-center>
                        <h3 class="grey--text font-weight-light">No Resolved Requests.</h3>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <!-- Device Details -->

          <v-flex xs12 sm5 md5 mb-1>
            <v-card class="rounded-card" heigh="360px">
              <v-card-text>
                <h2 class="dark-grey--text">Device Details</h2>
                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 text-xs-left>
                      <v-layout justify-center>
                        <v-flex
                          xs6
                          v-if="serviceAccount.device&&serviceAccount.device.deviceMakeModel"
                        >
                          <h2 class="subheading grey--text font-weight-bold">Make & Model :</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                          >{{serviceAccount.device.deviceMakeModel.deviceMake.name}} {{serviceAccount.device.deviceMakeModel.name}}</h3>
                        </v-flex>
                      </v-layout>

                      <v-layout justify-center  align-center :key="onuKey">
                        <v-flex xs6 >
                          <h2 class="subheading grey--text font-weight-bold" :key="onuKey" v-if="deviceDetail&&deviceDetail.status">Status:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <v-chip color="light-green" class="white--text" :key="onuKey" v-if="deviceDetail&&deviceDetail.status&&deviceDetail.status.isOnline">Online</v-chip>
                          <v-chip color="red" class="white--text" :key="onuKey" v-else-if="deviceDetail&&deviceDetail.status&&!deviceDetail.status.isOnline">Offline</v-chip>
                        </v-flex>
                      </v-layout>

                      <v-layout justify-center>
                        <v-flex xs6 v-if="serviceAccount.device&&serviceAccount.device.ponMac" >
                          <h2 class="subheading grey--text font-weight-bold">PON MAC/FSAN:</h2>
                        </v-flex>
                        <v-flex xs6 style="cursor: pointer" @click="redirectToDevice(serviceAccount.deviceId)">
                          <h3 class="grey--text font-weight-light" >{{serviceAccount.device.ponMac}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center :key="onuKey">
                        <v-flex :key="onuKey" xs6  v-if="deviceDetail&&deviceDetail.details">
                          <h2 class="subheading grey--text font-weight-bold" :key="onuKey">Distance to OLT:</h2>
                        </v-flex>
                        <v-flex :key="onuKey" xs6>
                          <span class="grey--text font-weight-light" v-if="deviceDetail&&deviceDetail.details" :key="onuKey">{{deviceDetail.details.ONTRANGING}} m</span>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="deviceDetail&&deviceDetail.details" :key="onuKey">
                        <v-flex :key="onuKey" xs6 >
                          <h2 class="subheading grey--text font-weight-bold" :key="onuKey">Temperature:</h2>
                        </v-flex>
                        <v-flex :key="onuKey" xs6>
                          <span class="grey--text font-weight-light" :key="onuKey" v-if="deviceDetail&&deviceDetail.details">{{deviceDetail.details.OPTICSTXTEMP}} C</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
                <!-- <h2 style="text-align:center" class="dark-grey--text" v-if="serviceAccount.device&&serviceAccount.device.acsDevice&&online">Speed Test   <v-btn v-if="serviceAccount.device&&serviceAccount.device.acsDevice&&online" small round color="primary" @click="testSpeed()">Run</v-btn> -->
            
            <!-- <v-btn v-else disabled round color="primary" small>Unavailable</v-btn> -->
            <!-- </h2> -->
         
                      <v-layout justify-center align-center v-if="visibleDownload">
                        <v-layout justify-center align-center v-if="visibleDownload">
                          <v-flex xs6>
                            <br>
                   <vue-loaders-ball-pulse scale="1"
                  
                  :key="visibleDownload"
                  color="#99cc33"
                ></vue-loaders-ball-pulse>                
                       <h4 class="grey--text" v-if="visibleDownload">Testing Download Speed</h4>
                       <br><br>
                          </v-flex>
                  </v-layout>
                                <v-flex justify-center v-if="downloadSpeed&&!visibleDownload" xs6 >
                        <VueSvgGauge
                          :start-angle="-110"
                          :end-angle="110"
                          :min="0"
                          :max="maxDownload"
                          :value="downloadSpeed"
                          :separator-step="25"
                          base-color="#d0cdcd"
                          :gauge-color="[{ offset: 0, color: 'orange'}, { offset: 100, color: 'green'}]"
                          :scale-step="5"
                          :inner-radius="60"
                        />
                        </v-flex>
                      </v-layout>
                        <v-layout v-if="downloadSpeed&&!visibleDownload">
                          <v-flex xs6>
                          <span
                            class="grey--text font-weight-bold"
                          >Download Speed: </span>
                        </v-flex>
                         <v-flex xs6 wrap>
                          <span
                            class="grey--text font-weight-light"
                          >{{downloadSpeed}} Mbps</span>
                        </v-flex>
                       </v-layout>
                       <v-layout style="text-align:center" v-if="showDownloadError">
                       <v-flex xs12>
                         <span style="text-align:center" class="grey--text font-weight-bold">An error occured while testing download speed</span>
                         </v-flex>
                          </v-layout>
                        <br><br>

                        <v-layout justify-center align-center>
                        <v-layout justify-center align-center v-if="visibleUpload">
                          <v-flex xs8>
                   <vue-loaders-ball-pulse scale="1"
                  
                  :key="visibleUpload"
                  color="#99cc33"
                ></vue-loaders-ball-pulse>
                       <h4 class="grey--text" v-if="visibleUpload">Testing Upload Speed</h4>
                           <br><br>
                          </v-flex>
                  </v-layout>
                                <v-flex justify-center v-if="uploadSpeed&&!visibleUpload" xs6 >
                        <VueSvgGauge
                          :start-angle="-110"
                          :end-angle="110"
                          :min="0"
                          :max="maxUpload"
                          :value="uploadSpeed"
                          :separator-step="25"
                          base-color="#d0cdcd"
                          :gauge-color="[{ offset: 0, color: 'orange'}, { offset: 100, color: 'green'}]"
                          :scale-step="5"
                          :inner-radius="60"
                        />
                        </v-flex>
                      </v-layout>
                       <v-layout v-if="uploadSpeed&&!visibleUpload">
                          <v-flex xs6>
                          <span
                            class="grey--text font-weight-bold"
                          >Upload Speed: </span>
                        </v-flex>
                         <v-flex xs6 wrap>
                          <span
                            class="grey--text font-weight-light"
                          >{{uploadSpeed}} Mbps</span>
                        </v-flex>
                       </v-layout>
                       <v-layout style="text-align:center" v-if="showUploadError">
                         <v-flex xs12>
                         <span style="text-align:center" class="grey--text font-weight-bold">An error occured while testing upload speed</span>
                         </v-flex>
                       </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>

         
        </v-layout>
      <!-- </v-container> -->
    </v-card>

 <!-- Add ticket Modal -->
    <v-dialog v-model="addTicketModal" persistent max-width="1000px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">ADD TICKET: {{ticketItem.dueDate}}</h3>
          <v-spacer></v-spacer>

          <v-btn
            v-if="ticketItem.ticketCategoryId&&ticketItem.ticketCategoryItemId&&ticketItem.currentStatus&&ticketItem.importance&&ticketItem.dueDate"
            flat
            color="white"
            class="white--text"
            @click="createNewTicket()"
          >Save</v-btn>
          <v-btn v-else disabled flat>Save</v-btn>
          <v-btn
            flat
            color="white"
            class="white--text"
            @click="addTicketModal=false, ticketItem={}"
          >X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout justify-center align-center>
            <v-flex>
              <v-checkbox label="Add from template" v-model="addTemplate"></v-checkbox>
            </v-flex>
            <v-flex v-if="addTemplate">
              <v-autocomplete
                v-model="ticketItem.ticketTemplateId"
                :items="ticketTemplates"
                clearable
                item-text="name"
                item-value="id"
                label="Ticket Template"
                @click:clear="clearTemplate()"
                v-on:change="populateTemplate()"
              ></v-autocomplete>
            </v-flex>
            <v-flex>
              <v-checkbox label="Full Day Event" v-model="dateTimeSelect"></v-checkbox>
            </v-flex>
            <v-flex>
              <VueCtkDateTimePicker
                :minDate="today"
                label="Select a Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="ticketItem.dueDate"
              />
            </v-flex>
            <v-flex>
              <VueCtkDateTimePicker
                v-if="!dateTimeSelect"
                format="HH:mm"
                formatted="HH:mm"
                minuteInterval="5"
                label="Select Time"
                only-time
                v-model="ticketItem.dueTime"
              />
            </v-flex>
          </v-layout>
          <v-layout justify-center align-center>
            <v-flex xs3 mx-2>
              <v-autocomplete
                :items="ticketCategories"
                label="Select a Ticket Category"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-2>
              <v-autocomplete
                v-if="ticketItem.ticketCategoryId"
                :items="filteredCategoryItems"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryItemId"
              ></v-autocomplete>
              <v-autocomplete
                v-else
                disabled
                :items="ticketCategories"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-2>
              <v-select :items="statuses" label="Status" v-model="ticketItem.currentStatus"></v-select>
            </v-flex>
            
          </v-layout>
          <v-layout justify-center align-center>
             <v-flex xs3 mx-2>
             <v-autocomplete
              clearable
                :items="userRoles"
                label="User Role"
                item-text="name"
                item-value="id"
                v-model="ticketItem.userRoleId"
              ></v-autocomplete>
             </v-flex>
            <v-flex xs3 mx-2>
              <v-autocomplete
              v-if="ticketItem.userRoleId"
                v-model="ticketItem.assignedToId"
                :items="filteredUsers"
                chips
                clearable
                item-text="name"
                item-value="id"
                label="Assign Ticket to a User"
              >
                <template v-slot:selection="{ attr, on, item, selected }">
                  <v-chip
                    v-bind="attr"
                    :input-value="selected"
                    color="blue-grey"
                    class="white--text"
                    v-on="on"
                  >
                    <v-icon left>person</v-icon>
                    <span>{{item.name}} {{item.surname}}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <v-avatar
                    size="35px"
                    color="primary"
                    class="title font-weight-light white--text"
                    v-if="item"
                  >{{ item.name.charAt(0) }}{{ item.surname.charAt(0) }}</v-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="grey--text ml-3">{{item.name}} {{item.surname}}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
               <v-autocomplete 
                 v-else
                 disabled
                 v-model="filterAssignedToId"
                :items="filteredUsers"
                chips
                clearable
                item-text="name"
                item-value="id"
                label="Assigned User"
              >
              </v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-2>
              <v-select
                :items="importanceOptions"
                label="Importance"
                v-model="ticketItem.importance"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout justify-center align-center>
            <v-textarea label="Description" outline auto-grow v-model="ticketItem.description"></v-textarea>
          </v-layout>
          <v-layout justify-center v-if="ticketAssignedLog.length>0">
            <v-flex xs12>
              <h3 class="grey--text">Assignment Log:</h3>
            </v-flex>
            <v-flex xs12 v-for="assigned in ticketAssignedLog" :key="assigned">
              <v-layout justify-left align-center class="text-xs-left">
                <v-flex xs4>
                  <h3
                    class="grey--text"
                  >{{assigned.assignedBy.name}} {{assigned.assignedBy.surname}}</h3>
                </v-flex>
                <v-flex xs4>
                  <h3
                    class="grey--text"
                  >{{assigned.assignedTo.name}} {{assigned.assignedTo.surname}}</h3>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout justify-center align-center>
            <v-flex xs3>
              <h3 class="grey--text">Comments:</h3>
            </v-flex>
            <v-flex xs3>
              <v-icon color="primary" @click="addCommentBox=true">add_circle_outline</v-icon>
            </v-flex>
          </v-layout>
          <v-flex xs12 v-if="ticketCommentLog.length===0&&!addCommentBox">
            <h3 class="grey--text font-weight-light">No Comments</h3>
          </v-flex>
          <v-flex xs12 v-if="addCommentBox">
            <v-textarea label="Comment" outline auto-grow v-model="comment"></v-textarea>
            <v-btn round color="primary" class="white--text" @click="addComment(comment)">Comment</v-btn>
          </v-flex>
           <v-layout>
          <v-card flat style="overflow-y: auto; max-height:1000px" >
               <v-container style="text-align:left" >
                      <v-layout wrap>
          <v-flex xs12 v-for="comment in ticketCommentLog" :key="comment.createdAt">
            <v-layout justify-left align-center>
              <v-flex xs2>
                <span class="grey--text font-weight-light">{{formatDateTime(comment.createdAt)}}</span>
              </v-flex>
              <v-flex xs2>
                <span
                  class="grey--text font-weight-light"
                >{{comment.commentedBy.name}} {{comment.commentedBy.surname}}</span>
              </v-flex>
              <v-flex xs8>
                <span class="grey--text font-weight-light">{{comment.comment}}</span>
              </v-flex>
            </v-layout>
          </v-flex>
                      </v-layout>
               </v-container>
               </v-card>
               </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="changeRequestModal" persistent width="750px">
      <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Log Change Request</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="changeRequestModal=false,changeRequestItem={}">X</v-btn>
        </v-toolbar>
        <v-card-text pa-2>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex sm12 md12>
                <v-autocomplete
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  :items="populateRequestTypes"
                  v-model="changeRequestItem.requestType"
                  label="Change Request Type"
                ></v-autocomplete>
              </v-flex>
              <v-flex
                xs12
                sm12
                md12
                v-if="changeRequestItem.requestType=='Upgrade'||changeRequestItem.requestType=='Downgrade'"
              >
                <v-text-field
                  flat
                  color="primary"
                  v-model="serviceAccount.packagesIsp.name"
                  label="From"
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm12
                md12
                v-if="changeRequestItem.requestType=='Upgrade'||changeRequestItem.requestType=='Downgrade'"
              >
                <v-autocomplete
                  v-if="selectablePackages.length>0"
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  return-object
                  :items="selectablePackages"
                  v-model="changeRequestItem.toPackage"
                  item-value="id"
                  label="*To"
                >
                  <template v-slot:selection="data">{{ data.item.name }}</template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-tile-content>
                        <v-list-tile-title class="grey--text font-weight-bold">{{data.item.name}} <span v-if="data.item.packagesFno.isGlobal">(Globally Available)</span></v-list-tile-title>
                        <v-list-tile-sub-title>
                          <v-layout align-center class="grey--text font-weight-light">
                            <v-icon color="light-green">arrow_drop_down</v-icon>
                            {{data.item.packagesFno.speedProfile.downloadMbps}}
                            <v-icon color="red">arrow_drop_up</v-icon>
                            {{data.item.packagesFno.speedProfile.uploadMbps}}
                          </v-layout>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
                <span
                  class="grey--text"
                  v-else-if="changeRequestItem.requestType =='Upgrade'"
                >No Upgradeable Packages available.</span>
                <span
                  class="grey--text"
                  v-else-if="changeRequestItem.requestType =='Downgrade'"
                >No Downgradeable Packages available.</span>
              </v-flex>
              <v-flex
                py-3
                xs12
                sm6
                md6
                v-if="changeRequestItem.requestType!==''&&changeRequestItem.requestType!==null&&changeRequestItem.requestType"
              >
                <h3 class="grey--text">Requested Change Date:</h3>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="changeRequestItem.requestType!==''&&changeRequestItem.requestType!==null&&changeRequestItem.requestType"
              >
                <v-menu :close-on-content-click="false">
                  <v-text-field
                    :value="changeRequestItem.requestedChangeDate"
                    slot="activator"
                    label="Change Date"
                    prepend-icon="date_range"
                    read-only
                    required
                  ></v-text-field>
                  <v-date-picker :min="today" v-model="changeRequestItem.requestedChangeDate"></v-date-picker>
                </v-menu>
              </v-flex>
                <v-flex sm8 md8 v-if="changeRequestItem.requestType=='Migration'&&changeRequestItem.requestedChangeDate">
                 <v-autocomplete
            v-model="filterNetwork"
            :items="networks"
            clearable
            item-text="name"
            item-value="id"
            label="Migration Location Network"
          ></v-autocomplete>

              </v-flex>
              <v-flex sm4 md4 v-if="changeRequestItem.requestType=='Migration'&&changeRequestItem.requestedChangeDate&&filterNetwork">
                 <v-btn flat color="primary" @click="attachLocationModal=true">
              <v-icon>add_circle_outline</v-icon>Attach Location</v-btn>

              </v-flex>
               <v-flex sm12 md12  v-if="changeRequestItem.requestType=='Migration'&&filterNetwork&&changeRequestItem.migrationLocation">
              <v-text-field
                  label="Migration Location"
                   v-model="changeRequestItem.migrationLocation.locationDescription"
                   disabled
               ></v-text-field>

               <v-card v-if="previousAccounts">
                   <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 text-xs-left  v-for="serviceAccount in previousAccountsList" :key="serviceAccount.id">
                      <v-layout justify-center>
                        <v-flex xs8 v-if="serviceAccount.serviceAccountIdentifier">
                          <h2 class="subheading grey--text font-weight-bold">Account Code:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3
                            class="grey--text font-weight-light"
                          >{{serviceAccount.serviceAccountIdentifier}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="serviceAccount.initialActivation">
                        <v-flex xs8>
                          <h2
                            class="subheading grey--text font-weight-bold"
                          >Initial Activation Date:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3 class="grey--text font-weight-light">
                            <v-chip
                              small
                              color="primary"
                              class="white--text font-weight-bold"
                            >{{formatDate(serviceAccount.initialActivation)}}</v-chip>
                          </h3>
                        </v-flex>
                      </v-layout>

                      <v-layout justify-left>
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">Last Update:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3 class="grey--text font-weight-light">
                            <v-chip
                              small
                              color="primary"
                              class="white--text font-weight-bold"
                            >{{formatDate(serviceAccount.createdAt)}}</v-chip>
                          </h3>
                        </v-flex>
                      </v-layout>

                      <v-layout justify-center v-if="serviceAccount.packagesIspId!==null">
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">Data Package:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3
                            class="grey--text font-weight-light"
                          >{{serviceAccount.packagesIsp.customerOrganisation.name}} | {{serviceAccount.packagesIsp.name}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="serviceAccount.packagesIspId!==null">
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">Data Package Term:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3
                            class="grey--text font-weight-light"
                          >{{serviceAccount.packagesIsp.term}}</h3>
                        </v-flex>
                      </v-layout>
                       <v-layout v-if="serviceAccount.fnoDeactivationDate" justify-left>
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">FNO Deactivation:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3 class="grey--text font-weight-light">
                            <v-chip
                              small
                              color="primary"
                              class="white--text font-weight-bold"
                            >{{formatDate(serviceAccount.fnoDeactivationDate)}}</v-chip>
                          </h3>
                        </v-flex>
                      </v-layout>
                            <v-layout> 
                               <v-flex xs12>
                               <v-checkbox label="Terminate" v-model="serviceAccount.terminate" @change="terminate(serviceAccount)"></v-checkbox>
                               </v-flex>
                            </v-layout>
                    </v-flex>
                   
                  </v-layout>
                </v-container>
               

               </v-card>
               </v-flex>
               <v-flex sm12 md12 v-if="previousAccounts">
                  <span
                  class="grey--text"
                >Other Service Accounts on Location</span>
               </v-flex>
               <v-flex sm12 md12 v-if="noZhoneDeviceOnLocation&&(serviceAccount.device.Handle_ID!==null&&serviceAccount.device.Handle_ID!==0)">
                  <span
                  class="grey--text"
                >No Zhone Device Installed on Location</span>
               </v-flex>
               <v-flex sm12 md12 v-if="noAcsDeviceOnLocation&&(serviceAccount.device.acsDevice===true)">
                  <span
                  class="grey--text"
                >No Acs Device Installed on Location</span>
               </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
            v-if="validateMigration()===true&&submit===true"
              color="primary"
              round
              class="white--text"
              @click="logServiceAccountChange(changeRequestItem)"
            >Submit</v-btn>
            <v-btn
            v-else
            disabled
              color="primary"
              round
              class="white--text"
            >Submit</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="attachLocationModal" max-width="800px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">Attach Location</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="attachLocationModal=false">X</v-btn>
        </v-toolbar>
        <v-card-text>
              <v-layout >
                <v-spacer></v-spacer>
           <v-flex xs6 mx-2>
        <v-text-field
          label="Search"
          v-model="search"
          clearable
          append-icon="search"
          v-on:keyup.enter="$router.push({name: $route.name, query:{offset: $route.query.offset, records: $route.query.records, search: search}})"
        ></v-text-field>      
           </v-flex> 
              </v-layout>
              <v-layout justify-center >
          <v-data-table
            :items="filteredLocations"
            :headers="locationHeaders"
            :rows-per-page-items="[10, 20, 50, 100, 250]"
             :pagination.sync="pagination"
             hide-actions            
          >
            <template v-slot:items="props">
              <td class="text-xs-center">
                <v-icon
                  @click="attachLocation(props.item)"
                  color="primary"
                >add_circle_outline</v-icon>
              </td>
              <td class="text-xs-center">{{props.item.unitNo}}</td>
              <td class="text-xs-center">{{props.item.erfNo}}</td>
              <td class="text-xs-center">{{props.item.otherNo}}</td>
              <td class="text-xs-center">{{props.item.complexStreetName}}</td>
              <td
                class="text-xs-center"
              >{{props.item.subComplexName}}</td>
              <td class="text-xs-center">{{props.item.locationNetwork.name}}</td>
            </template>
          </v-data-table>
              </v-layout>
              <v-layout justify-center>
        <div class="text-xs-center pt-2 white" :key="$route.query.offset">
      <v-pagination v-model="page" 
      :length="Math.ceil(pagination.totalItems/pagination.rowsPerPage)" :total-visible="7">
      </v-pagination>
    </div>
              </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="denyRequestModal" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h2 class="headline white--text">REASON FOR DENYING REQUEST:</h2>
        </v-toolbar>
        <v-layout justify-center>
          <v-flex xs10>
          <v-textarea v-model="denyReason" label="Please provide a reason"></v-textarea>
        </v-flex>
        </v-layout>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="denyRequestModal=false,denyReason=''">Cancel</v-btn>
          <v-btn
            v-if="denyReason!==''"
            color="primary"
            round
            @click="denyRequestChange(denyItem)"
          >Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

     <v-dialog persistent v-model="acceptReactivationRequest" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h2 class="headline white--text">Confirm device</h2>
          <v-spacer></v-spacer>
          <v-btn flat @click="changeRequestItem={},acceptReactivationRequest=false">X</v-btn>
        </v-toolbar>
        <v-layout justify-center>
          <v-flex xs10>
          <v-radio-group v-model="changeRequestItem.device" column mandatory>
              <v-radio
              v-for="template in locationDevices"
              :key="template.id"
                :label="`${template.deviceMakeModel.deviceMake.name} ${template.deviceMakeModel.name} | ${template.ponMac}`"
                :value="template"
              ></v-radio>
                </v-radio-group>
        </v-flex>
        </v-layout>
        <v-card-actions class="justify-center layout px-0">
          <v-btn
            v-if="changeRequestItem.device"
            color="primary"
            round
            @click="acceptRequestChange(changeRequestItem)"
          >Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Wifi Dialog -->

    <v-dialog v-model="addWifiProfileItem" max-width="750px" persistent>
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">{{wifiItem.type}} WIFI PROFILE</h1>
        </v-toolbar>
        <v-card-text>
          <v-layout>
            <v-flex xs6 px-1>
              <v-text-field v-model="wifiItem.ssid" label="SSID"></v-text-field>
            </v-flex>
            <v-flex xs6 px-1>
              <v-text-field v-model="wifiItem.password" label="Password"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6 px-1>
              <v-select
                v-model="wifiItem.encryption"
                label="Encryption Type"
                :items="encryptionTypes"
              ></v-select>
            </v-flex>
            <v-flex xs6 px-1>
              <v-select
                v-model="wifiItem.frequencyBand"
                label="Frequency Band"
                :items="availableFrequency"
              ></v-select>
            </v-flex>
          </v-layout>
         
          <v-layout>
             <v-flex xs4 px-4>
            <v-text-field v-model="wifiItem.channel" label="Channel" type="number"></v-text-field>
          </v-flex>
            <v-flex xs3 ml-1 px-1>
              <v-switch v-model="wifiItem.enable" label="Enabled"></v-switch>
            </v-flex>
            <v-flex xs3 px-1>
              <v-switch v-model="wifiItem.hidden" label="Hidden"></v-switch>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              class="primary white--text"
              round
              @click="addWifiProfileItem=false, wifiItem={}"
            >Cancel</v-btn>
            <v-btn class="primary white--text" round @click="saveWifiProfile()">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="migrationErrorModal" width="500px" persistent>
      <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Error Processing Request</h3>
        </v-toolbar>
        <v-card-text>
          <v-layout justify-center align-center wrap>
            <v-flex xs10 mx-1>
              <span class="grey--text">{{migrationErrorMessage}}</span>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center align-center>
            <v-btn color="primary" round class="white--text" @click="migrationErrorMessage='', migrationErrorModal=false">Okay</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="suspendDialog" persistent max-width="750px" >
      <v-card >
        <v-toolbar flat color="primary">
          <h3 class="title white--text">
            SUSPEND
          </h3>
          <v-spacer></v-spacer>

          <v-btn
            flat
            color="white"
            class="white--text"
            @click="submitSuspend()"
            >Submit</v-btn
          >
           
          <v-btn
            flat
            color="white"
            class="white--text"
            @click="(suspendDialog = false)"
            >X</v-btn
          >
        </v-toolbar>
        <v-card-text>
          <v-layout justify-center align-center>
            <v-flex>
                <v-menu >
                <v-text-field
                  :value="formatDate(this.suspendItem.dueDate)"
                  slot="activator"
                  label="Preferred Date"
                  prepend-icon="date_range"
                ></v-text-field>
                <v-date-picker :min="todaySuspend" v-model="suspendItem.dueDate"></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
 </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { VueSvgGauge } from 'vue-svg-gauge'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import configData from "../../../config/config.json";
export default {
  components: {
    VueCtkDateTimePicker: VueCtkDateTimePicker,
    VueSvgGauge,
    Loading: Loading
  },
  data() {
    return {
      acceptReactivationRequest: false,
      changeRequestItem: {},
      suspendDialog:false,
      suspendItem: {dueDate: ''},
      denyingRequestChange:false,
      acceptingRequestChange:false,
      populateRequestTypes:[],
      submit:true,
      online:false,
      terminatePreviousList:[],
      migrationLocationSet:false,
      previousAccountsList:[],
      pagination: { totalItems: 0 },
      previousAccounts:false,
      deviceDetail: {},
      onuKey: 0,
      noAcsDeviceOnLocation:false,
      noZhoneDeviceOnLocation:false,
      filterNetwork:null,
      search: "",
      page: 1,
      locationLength: 0,
      filteredLocations: [],
      networks:[],
      attachLocationModal: false,
      showDownloadError:false,
      showUploadError:false,
      loader:null,
      config:null,
      keySpeed:0,
      maxDownload:0,
      maxUpload:0,
      acsDevice:false,
      uploadSpeed:0,
      downloadSpeed:0,
      visibleDownload:false,
      visibleUpload:false,
      dateTimeSelect:false,
      addTemplate:false,
      addCommentBox: false,
      statuses: ["Incomplete", "Pending", "In Progress", "Complete"],
      importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
      ticketItem: {},
      ticketCategories:[],
      ticketCategoryItems:[],
      filteredCategoryItems: [],
      filteredUsers: [],
      ticketAssignedLog: [],
      ticketCommentLog: [],
      filteredTickets: {},
      ticketTemplates: [],
      locationDevices: [],
      userRoles:[],     
      addTicketModal: false,
      addWifiProfileItem: false,
      allOpenTickets: [],
      allPendingRequests: [],
      allIspPackages: [],
      allResolvedRequests: [],
      allResolvedTickets: [],
      allServiceAccountHistory: [],
      availableFrequency: [],
      changeRequestItem: {},
      changeRequestModal: false,
      denyItem: {},
      denyReason: '',
      denyRequestModal: false,
      migrationErrorMessage: '',
      migrationErrorModal: false,
      encryptionTypes: ["WEP", "WPA", "WPA2", "WPA+WPA2"],
      errorSnackbar: false,
      internetServices: [],
      pendingRequests: [],
      pendingTickets: [],
      pendingRequestPage: 1,
      pendingTicketPage: 1,
      resolvedRequests: [],
      resolvedTickets: [],
      resolvedRequestPage: 1,
      resolvedTicketPage: 1,
      selectablePackages: [],
      serviceAccount: null,
      serviceAccountHistory: [],
      serviceAccountHistoryPage: 1,
      showInternet: true,
      showWifi: false,
      showVoip: false,
      showPendingRequests: true,
      showResolvedRequests: false,
      showPendingTickets: true,
      showResolvedTickets: false,
      snackbar: false,
      text: '',
      today: new Date().toISOString().substr(0, 10),
      top: "y",
      wifiItem: {},
      wifiServices: [],
      voipServices: [],
        rgModeArray:[
            {id: 1, name: 'Routed'},
            {id: 2, name: 'BRouted'},
            {id: 3, name: 'rPPPoE'},
            {id: 4, name: 'bPPPoE'},
            {id: 5, name: 'Bridged'},
            {id: 6, name: 'Not Applicable'}

        ],
        tpTypeArray: [
            {id: 1, name: 'Ethernet UNI'},
            {id: 2, name: 'VCC Termination Point'},
            {id: 3, name: 'Mapper Service Profile'},
            {id: 4, name: 'IP Host Config Data'},
            {id: 5, name: 'GEM Interworking Termination Point'},
            {id: 6, name: 'Multicast GEM Interworking Termination Point'},
            {id: 7, name: 'xDSL UNI'},
            {id: 8, name: 'VDSL UNI'},
            {id: 9, name: 'Ether Flow Termination Point'},
            {id: 10, name: 'Physical Path UNI'},
            {id: 11, name: 'Physical Path RF Video UNI'},
            {id: 12, name: 'Physical Path IPTV UNI'},
            {id: 13, name: 'H248 Voice'},
            {id: 14, name: 'SIP Voice'},
            {id: 15, name: 'SIP PLAR Voice'},
            {id: 16, name: 'PWE Termination'},
            {id: 17, name: 'Virtual Ethernet'},
            {id: 18, name: 'dot11 Termination Point'},
            {id: 19, name: 'Fiber LAN Termination Point'},
            {id: 20, name: 'TR69 Termination Point'},
            {id: 21, name: 'Management Termination Point'},
            {id: 22, name: 'MGCP Voice Termination Point'}
        ],
       locationHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Unit No",
          align: "center",
          value: "unitNo"
        },
        {
          text: "Erf No",
          align: "center",
          value: "erfNo"
        },
        {
          text: "Other No",
          align: "center",
          value: "otherNo"
        },
        {
          text: "Street Name",
          align: "center",
          value: "complexStreetName"
        },
        {
          text: "Sub Complex",
          align: "center",
          value: "locationNetworkSubComplex.subcomplexName"
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name"
        }
      ],
    };
  },
  watch: {
    "$route.params.serviceAccountId": {
      immediate: true,
      async handler(value) {
        if(value){
          this.initialize()
        }
      }
    },
    "ticketItem.ticketTemplateId": {
      immediate: true,
      async handler(value) {
        if (value === null && this.ticketItem.ticketCategoryId != null) {
          Api()
            .get(
              "/ticketCategoryItem/byCategory/" +
                this.ticketItem.ticketCategoryId
            )
            .then(response => {
              for (let k = 0; k < response.length; k++) {
                this.filteredCategoryItems = response.data[k];
              }
            });
        }
      }
    },
    "ticketItem.userRoleId":{
       immediate: true,
      async handler(value) {
        if (value && value !== null) {
          Api().get('/userRoleContact/byUserRole/'+ value).then(response=>{
            this.filteredUsers = response.data.map(x=>x.contact)
          })
        }
      }
    },
    "ticketItem.ticketCategoryId": {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          this.filteredCategoryItems = await this.ticketCategoryItems.filter(
            function(el) {
              return el.ticketCategoryId === value;
            }
          );
        } else {
          this.filteredCategoryItems = this.ticketCategoryItems;
        }
      }
    },
    "ticketItem.assignedToId": {
      immediate: true,
      handler(value) {
        
        if (this.editTicketModal && value !== this.initialAssignedId) {
          if (
            this.ticketItem.id &&
            value !== null &&
            typeof value !== "undefined"
          ) {
            Api()
              .post("/ticketAssignLog", {
                ticketId: this.ticketItem.id,
                assignedToId: this.ticketItem.assignedToId
              })
              .then(response => {
                let find = this.users.find(x => x.id === value);
                response.data.assignedTo = find;
                response.data.assignedBy = this.$store.state.user;
                this.ticketAssignedLog.push(response.data);
              });
            Api().put("/ticket/" + this.ticketItem.id, {
              assignedToId: this.ticketItem.assignedToId
            });
          }
        }
      }
    },
       resolvedTicketPage(value) {
      this.resolvedTickets = this.allResolvedTickets.slice(value - 1, value);
    },
    pendingTicketPage(value) {
      this.pendingTickets = this.allOpenTickets.slice(value - 1, value);
    },
    resolvedRequestPage(value) {
      this.resolvedRequests = this.allResolvedRequests.slice(value - 1, value);
    },
    pendingRequestPage(value) {
      this.pendingRequests = this.allPendingRequests.slice(value - 1, value);
    },
    serviceAccountHistoryPage(value){
      if(value==1){
      this.serviceAccountHistory = this.allServiceAccountHistory.slice(0, 2);

      } else {
      this.serviceAccountHistory = this.allServiceAccountHistory.slice(value*2 - 2, value*2);

      }
    },
    "changeRequestItem.requestType": {
      immediate: true,
      handler(value) {
        if (value == "Upgrade") {
          this.selectablePackages = this.allIspPackages.filter(x => {
            return (
              (x.locationNetworkId ===
                this.serviceAccount.location.locationNetworkId ||
                x.packagesFno.isGlobal) &&
              x.packagesFno.speedProfile.downloadMbps >=
                this.serviceAccount.packagesIsp.packagesFno.speedProfile
                  .downloadMbps ||
              x.packagesFno.speedProfile.uploadMbps >
                this.serviceAccount.packagesIsp.packagesFno.speedProfile
                  .uploadMbps
            );
          });
        } else if (value == "Downgrade") {
          this.selectablePackages = this.allIspPackages.filter(x => {
            return (
              (x.locationNetworkId ===
                this.serviceAccount.location.locationNetworkId ||
                x.packagesFno.isGlobal) &&
              x.packagesFno.speedProfile.downloadMbps <=
                this.serviceAccount.packagesIsp.packagesFno.speedProfile
                  .downloadMbps ||
              x.packagesFno.speedProfile.uploadMbps <
                this.serviceAccount.packagesIsp.packagesFno.speedProfile
                  .uploadMbps
            );
          });
        }
      }
    },
     page(value) {
      this.pagination.page = this.page;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.search) {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records,
              search: this.$route.query.search
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records
            }
          });
        }
      }
    },
     filterNetwork(value) {
      if (value !== null && typeof value !== "undefined") {
         Api()
        .get('/Locations/byNetwork/'+ value +'/activeFilter').then(response=>{
                this.filteredLocations = response.data.result
                this.locationLength=response.data.count
                this.pagination.totalItems =this.locationLength
                //this.attachLocationModal=true
        })
     
      }
    },
    '$route.query.search':{
      immediate: true,
      handler(value){
      if(this.$route.query.search&&value!==""&&value != null){      
        Api()
        .get('/Locations/byNetwork/'+ this.filterNetwork+'/activeFilter',{
          params: {
          search: value,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.filteredLocations=response.data.result
          this.locationLength=response.data.count
          this.pagination.totalItems =this.locationLength
          })} else if(this.$route.query.offset){
             Api()
        .get('/Locations/byNetwork/'+ this.filterNetwork+'/activeFilter',{
          params: {
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.filteredLocations=response.data.result
          this.locationLength=response.data.count
          this.pagination.totalItems =this.locationLength
         })

          }
      }
    },
    '$route.query.offset': {
       immediate: true,
      handler(value){
        this.loading=true
      if(value!==""&&value != null&&this.$route.query.search&&this.$route.query.search!="" &&this.$route.query.search!== null){      
        
        Api()
        .get('/Locations/byNetwork/'+ this.filterNetwork+'/activeFilter',{
          params: {
          search: this.$route.query.search,
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.filteredLocations=response.data.result
          this.locationLength=response.data.count
          this.pagination.totalItems =this.locationLength
          })
      } else if(value!==""&&value != null){
         Api()
        .get('/Locations/byNetwork/'+ this.filterNetwork+'/activeFilter',{
          params: {
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.filteredLocations=response.data.result
          this.locationLength=response.data.count
          this.pagination.totalItems =this.locationLength
         })
      }
      }
    },
     "migrationLocationSet": {
      immediate: true,
      handler(value) {
        if(value===true){
     if(this.changeRequestItem.requestType==='Migration'&&this.changeRequestItem.migrationLocation){
     
     if(this.serviceAccount.device.acsDevice===true){
       Api().get('/devices/acs/byLocation/'+ this.changeRequestItem.migrationLocation.id).then(response=>{
        
        if(response.data.length>0){
           this.noAcsDeviceOnLocation = false

             Api().get('/serviceAccounts/active/byLocation/'+ this.changeRequestItem.migrationLocation.id).then(response=>{
            
             this.previousAccountsList = response.data
             this.previousAccountsList.map(x=>x.terminate = false)
        if(response.data.length>0){
          for(let k=0;k<response.data.length;k++){
            let endDate = new Date(response.data[k].fnoDeactivationDate)
            let requestDate =new Date(this.changeRequestItem.requestedChangeDate)
            if(endDate>requestDate|| response.data[k].fnoDeactivationDate===null){
              this.previousAccounts = true
              return false
            }else{
              this.previousAccounts = false
              return true
            }
          }
       }else{
          this.previousAccounts = false
          return true
       }
     })
       }else{
          this.noAcsDeviceOnLocation = true

            Api().get('/serviceAccounts/active/byLocation/'+ this.changeRequestItem.migrationLocation.id).then(response=>{
              this.previousAccountsList = response.data
              this.previousAccountsList.map(x=>x.terminate = false)
        if(response.data.length>0){
          for(let k=0;k<response.data.length;k++){
            let endDate = new Date(response.data[k].fnoDeactivationDate)
            let requestDate =new Date(this.changeRequestItem.requestedChangeDate)
            if(endDate>requestDate || response.data[k].fnoDeactivationDate===null){
              this.previousAccounts = true
              return false
            }else{
              this.previousAccounts = false
              return false
            }
          }
       }else{
          this.previousAccounts = false
           return false
       }
     })
       }
      
       })
     }else if(this.serviceAccount.device.Handle_ID!==0 && this.serviceAccount.device.Handle_ID!== null){
     Api().get('/devices/zhone/byLocation/'+ this.changeRequestItem.migrationLocation.id).then(response=>{
        
        if(response.data.length>0){
           this.noZhoneDeviceOnLocation = false

             Api().get('/serviceAccounts/active/byLocation/'+ this.changeRequestItem.migrationLocation.id).then(response=>{
            
             this.previousAccountsList = response.data
             this.previousAccountsList.map(x=>x.terminate = false)
        if(response.data.length>0){
          for(let k=0;k<response.data.length;k++){
            let endDate = new Date(response.data[k].fnoDeactivationDate)
            let requestDate =new Date(this.changeRequestItem.requestedChangeDate)
            if(endDate>requestDate|| response.data[k].fnoDeactivationDate===null){
              this.previousAccounts = true
              return false
            }else{
              this.previousAccounts = false
              return true
            }
          }
       }else{
          this.previousAccounts = false
          return true
       }
     })
       }else{
          this.noZhoneDeviceOnLocation = true

            Api().get('/serviceAccounts/active/byLocation/'+ this.changeRequestItem.migrationLocation.id).then(response=>{
              this.previousAccountsList = response.data
              this.previousAccountsList.map(x=>x.terminate = false)
        if(response.data.length>0){
          for(let k=0;k<response.data.length;k++){
            let endDate = new Date(response.data[k].fnoDeactivationDate)
            let requestDate =new Date(this.changeRequestItem.requestedChangeDate)
            if(endDate>requestDate || response.data[k].fnoDeactivationDate===null){
              this.previousAccounts = true
              return false
            }else{
              this.previousAccounts = false
              return false
            }
          }
       }else{
          this.previousAccounts = false
           return false
       }
     })
       }
      
       })
     }
       
     }else{
       return true
     }


this.migrationLocationSet=false
        }
      }
  },
  },
  async created() {
    this.initialize()
  },
  methods: {
    async initialize(){
       this.config = configData;
    await this.getServiceAccountDetails();
    this.getWifiProfiles()
    this.getInternetProfiles()
    this.getChangeRequests();
    this.getServiceAccountHistory();
    this.getActiveISPPackages();
    this.getTickets()  
    this.fetchOrgContacts();
    this.fetchUserRoles()
    this.fetchTicketCategories();
    this.fetchTicketCategoryItems();
    this.fetchTicketTemplates();
    this.fetchNetworks()
    
    this.$router.push({
          name: this.$route.name,
          query: { offset: "0", records: "10" }
        });
    },
    acceptReactivation(item){
      this.changeRequestItem = item
      this.acceptReactivationRequest = true
    },
    redirectToDevice(id){
      this.$router.push({
        path: "/devices/" + id,
      });
    },
    deviceStatus(ponMac){
      Api()
        .get("/acs/deviceDetail/" + ponMac)
        .then(response => {
          let online =  response.data.message.uptime > 0 ? true : false
          if(online ===true){
            this.online= true
          }
        })
    },
    async terminate(serviceAccount){
         if(serviceAccount.terminate===true){
           this.submit=true
            let obj = {
        status: "Pending",
        serviceAccountId: serviceAccount.id,
        serviceAccountIdentifier: serviceAccount.serviceAccountIdentifier,
        locationId: serviceAccount.locationId,
        migrationLocationId: serviceAccount.migrationLocationId || null,
        packagesIspId: serviceAccount.packagesIspId,
        locationDescription: serviceAccount.location.locationDescription,
        customerOrganisationId: serviceAccount.packagesIsp
          .customerOrganisationId,
        ispName: serviceAccount.customerOrganisation.name,
        requestType: 'Termination',
        isChange: serviceAccount.isChange,
        ispNotification: true,
        fnoNotification: true,
        ispContactName: null,
        fnoContactName:
          this.$store.state.user.name + " " + this.$store.state.user.surname,
        fromSpeedProfileName:
          serviceAccount.packagesIsp.packagesFno.speedProfile
            .downloadMbps +
          "/" +
          serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps,
        fromSpeedProfileId: serviceAccount.packagesIsp.packagesFno
          .speedProfileId,
        authenticationType: serviceAccount.authenticationType,
        pppoeUsername: serviceAccount.pppoeUsername || null,
        pppoePassword: serviceAccount.pppoePassword || null,
        IPoEMacAddress: serviceAccount.IPoEMacAddress || null,
        initialActivation: serviceAccount.initialActivation
          ? new Date(serviceAccount.initialActivation)
              .toISOString()
              .substr(0, 10)
          : null,
        fnoActivationDate: serviceAccount.fnoActivationDate
          ? new Date(serviceAccount.fnoActivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        fnoDeactivationDate: serviceAccount.fnoDeactivationDate
          ? new Date(serviceAccount.fnoDeactivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        ispActivationDate: serviceAccount.ispActivationDate
          ? new Date(serviceAccount.ispActivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        ispDeactivationDate: serviceAccount.ispDeactivationDate
          ? new Date(serviceAccount.ispDeactivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        requestedChangeDate: this.changeRequestItem.requestedChangeDate,
        staticIpv4: serviceAccount.staticIpv4 || null,
        staticIpv6: serviceAccount.staticIpv6 || null,
        deviceId: serviceAccount.deviceId,
        device: serviceAccount.device,
        deviceBridge: serviceAccount.deviceBridge|| null,
        deviceBridgeId: serviceAccount.deviceBridgeId,
        isDeleted: false,
        isActive: true
      }
      let same = false
      await this.terminatePreviousList.map(x=>{
        if(x.serviceAccountId===obj.serviceAccountId){
          same=true
        }
      })
      if(same===false){
        this.terminatePreviousList.push(obj)
        
      }
      
         }else if(serviceAccount.terminate===false){
              let index = this.terminatePreviousList.findIndex( x => x.serviceAccountId === serviceAccount.id );

              this.terminatePreviousList.splice(index,1)
              console.log(this.terminatePreviousList)
              this.submit=false
         }

    },
    validateMigration(){
      if(this.changeRequestItem.requestType==='Migration'){
       if(this.changeRequestItem.requestedChangeDate&&this.changeRequestItem.migrationLocation){
         if(this.serviceAccount.device.Handle_ID!==null&&this.serviceAccount.device.Handle_ID!==0){
           if(this.noZhoneDeviceOnLocation===false){
             if(this.previousAccountsList.length!==this.terminatePreviousList.length){
               return false
             }else{
               return true
             }
              
           }else{
             return false
           }
         }
         if(this.serviceAccount.device.acsDevice===true){
           if(this.noAcsDeviceOnLocation===false){
              if(this.previousAccountsList.length!==this.terminatePreviousList.length){
               return false
             }else{
               return true
             }
           }else{
             return false
           }
         }
        }else{
          return false
        }
      }else{
        if(this.changeRequestItem.requestedChangeDate){
        return true
        }else{
        return false
        }
      }

    },
    attachLocation(location){
        this.changeRequestItem.migrationLocation = location
        this.migrationLocationSet = true
        this.attachLocationModal=false
    },
      fetchNetworks() {
      Api()
        .get("/locationNetworks")
        .then(response => {
          this.networks = response.data;
        });
    },
   testSpeed(){
            this.visibleDownload = true                
          Api().get('/acs/speedTest/download/'+ this.serviceAccount.device.ponMac+'/'+ this.serviceAccount.device.id).then(response=>{
           
            this.downloadSpeed = response.data.downloadSpeed
            if(response.data.message==='OK'){
            this.visibleDownload = false 
            if(response.data.downloadSpeed===null){
              this.showDownloadError = true
            }else{
              this.showDownloadError = false
            }
            }else{
              this.downloadSpeed = 0
              this.showDownloadError = true
              this.visibleDownload = false 
            }
            this.visibleUpload=true
            //this.loader.hide()
                             
          Api().get('/acs/speedTest/upload/'+ this.serviceAccount.device.ponMac+'/'+ this.serviceAccount.device.id).then(response=>{
            
            this.uploadSpeed = response.data.uploadSpeed
            if(response.data.message==='OK'){
            this.visibleUpload = false 
            if(response.data.uploadSpeed===null){
              this.showUploadError = true
            }else{
              this.showUploadError = false
            }
            }else{
              this.uploadSpeed = 0
              this.showUploadError = true
              this.visibleUpload = false
            }
          })
          })
    },
      clearTemplate() {
      this.ticketItem.dueDate = "";
      this.ticketItem.dueTime = "";
      this.ticketItem.assignedToId = null;
      this.ticketItem.ticketCategoryItemId = null;
      this.ticketItem.ticketCategoryId = null;
    },
    populateTemplate() {
      this.clearTemplate();
      for (let i = 0; i < this.ticketTemplates.length; i++) {
        if (this.ticketTemplates[i].id === this.ticketItem.ticketTemplateId) {
          this.ticketItem.dueDate = this.ticketTemplates[i].dueDate;
          this.ticketItem.dueTime = this.ticketTemplates[i].dueTime;
          this.ticketItem.assignedToId = this.ticketTemplates[i].contactId;
          if (this.ticketTemplates[i].ticketCategoryItem !== null) {
            this.ticketItem.ticketCategoryItemId = this.ticketTemplates[
              i
            ].ticketCategoryItemId;
            this.ticketItem.ticketCategoryId = this.ticketTemplates[
              i
            ].ticketCategoryItem.ticketCategoryId;
          }
        }
      }
    },
    fetchUserRoles(){
      Api()
      .get('/userRole')
      .then(response=>{
        this.userRoles=response.data
      })
    },
    addTicket(date) {
      if (date == null) {
        this.addTicketModal = true;
        this.ticketItem = {
          importance: "Normal",
          currentStatus: "Pending",
          dueDate: this.formatDate(new Date())
        };
      } else {
        this.ticketItem = {
          importance: "Normal",
          currentStatus: "Pending",
          dueDate: this.formatDate(new Date(date))
        };
        this.addTicketModal = true;
      }
    },
      fetchTicketCategories() {
      Api()
        .get("/ticketCategory")
        .then(response => {
          this.ticketCategories = response.data;
        });
    },
     fetchTicketCategoryItems() {
      Api()
        .get("/ticketCategoryItem")
        .then(response => {
          this.ticketCategoryItems = response.data;
        });
    },
    async createNewTicket() {
      this.ticketItem.serviceAccountId= this.$route.params.serviceAccountId
      this.ticketItem.locationId= this.serviceAccount.locationId

      await Api()
        .post("/ticket", this.ticketItem)
        .then(response => {
          this.key++
          if (this.ticketCommentLog.length > 0) {
            for (let i = 0; i < this.ticketCommentLog.length; i++) {
              this.ticketCommentLog[i].ticketId = response.data.id;
            }
            Api()
              .post("/ticketComment", {
                batch: this.ticketCommentLog
              })
              .then(response => {});
          }
          if (this.ticketItem.assignedToId) {
            Api().post("/ticketAssignLog", {
              assignedToId: this.ticketItem.assignedToId,
              assignedById: this.$store.state.user.id,
              ticketId: response.data.id
            });
          }
          this.getTickets()  
      this.addTicketModal = false;
      this.ticketItem = {};
        })
    },
     fetchOrgContacts() {
      this.filteredUsers = [];
      Api()
        .get("/organisationContact")
        .then(async response => {
          this.filteredUsers = response.data.filter(function(el) {
            return el.userType !== "endClient";
          });
          let contactArray = await this.filteredUsers.map(x => x.contact);
          this.filteredUsers = contactArray;
        });
    },
      addComment(comment) {
      this.ticketCommentLog.push({
        commentedBy: this.$store.state.user,
        commentedById: this.$store.state.user.id,
        comment: comment,
        type: "comment",
        createdAt: new Date()
      });
      this.comment = "";
      this.addCommentBox = false;
    },
     fetchTicketTemplates() {
      Api()
        .get("/ticketTemplate")
        .then(response => {
          this.ticketTemplates = response.data;
        });
    },    
    async routeToTicketSummary(item){
     let url =item
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/ticketSummary/:ticketId'})
      await this.$store.dispatch('setCurrentRoute', route[0])
      this.$router.push({ path: "/ticketSummary/" + item });
    },
    addWifiProfileModal() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.wifiItem = {
          type: "ADD",
          ssid: "",
          password: "",
          channel: 0,
          encryption: "WPA2",
          enable: true,
          hidden: false,
          frequencyBand: this.availableFrequency[0],
          deviceBridgeId: this.serviceAccount.deviceBridgeId,
          customerOrganisationId: this.serviceAccount.customerOrganisationId
        };
        this.addWifiProfileItem = true;
      }
    },
    async suspendServices(item){
      if(this.authAdmin(this.$store.state.currentRoute)){
         this.suspendDialog=true    
         this.suspendItem =item       
      }
      },
       async submitSuspend(){
       let obj = {
        serviceAccountId: this.suspendItem.id,
        locationId: this.suspendItem.locationId,
        circuitNumber: this.suspendItem.circuitNumber,
        device: this.suspendItem.device,
        deviceBridgeId: this.suspendItem.deviceBridgeId,
        deviceBridge: this.suspendItem.deviceBridge,
        type: 'U2000',
        organisationId: this.$store.state.currentOrg.org.id,
        customerOrganisationId:  this.suspendItem.supplierOrganisationId,
        dueDate: this.suspendItem.dueDate
      }
      await Api().post('/serviceAccounts/suspendServices/'+this.suspendItem.id, obj).then(res=>{
        this.getServiceAccountDetails()
        this.getTickets()
        this.suspendDialog=false
      })
       },
    async reactivateServices(item){
      if(this.authAdmin(this.$store.state.currentRoute)){
        let obj = {
        serviceAccountId: item.id,
        locationId: item.locationId,
        circuitNumber: item.circuitNumber,
        device: item.device,
        deviceBridgeId: item.deviceBridgeId,
        deviceBridge: item.deviceBridge,
        type: 'U2000',
        organisationId: this.$store.state.currentOrg.org.id,
        customerOrganisationId:  item.supplierOrganisationId
      }
      await Api().post('/serviceAccounts/reactivateServices/'+item.id, obj).then(res=>{
        this.getServiceAccountDetails()
        this.getTickets()
      })
      }
    },
    denyRequestItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
       
      this.denyItem = Object.assign({}, item);
      this.denyRequestModal = true;
      }
    },
    async getActiveISPPackages() {
      await Api()
        .get(
          "/supplier/packagesIsps/networkCustomer/active/" +
            this.serviceAccount.location.locationNetworkId +
            "/" +
            this.serviceAccount.customerOrganisationId
        )
        .then(response => {
          this.allIspPackages = response.data;
        });
    },
    getU2000OnuStatus(obj){
       Api().get('/u2000/ontStatus', {
         params: {
           deviceName: obj.upstreamDevice.systemName,
           frameId: obj.frame,
           slotId: obj.slot,
           portId: obj.port,
           onuId: obj.ponId
         }
       }).then(res=>{
         this.deviceDetail.status = {}
         this.deviceDetail.status.isOnline = res.data.data.RUNSTAT == 'Up'?true:false
        this.deviceDetail.status.uptime = new Date(res.data.data.LSTUPTIME)
         this.deviceDetail.status.lastDowntime = new Date(res.data.data.LSTDOWNTIME)
         this.deviceDetail.status.lastDownCause = res.data.data.LSTDOWNCAUSE
         this.onuKey+=1
         console.log(this.deviceDetail)
       })
    },

    getU2000OnuDetails(obj){
       Api().get('/u2000/ontDDM', {
         params: {
           deviceName: obj.upstreamDevice.systemName,
           frameId: obj.frame,
           slotId: obj.slot,
           portId: obj.port,
           onuId: obj.ponId
         }
       }).then(res=>{
         this.deviceDetail.details = res.data.data
         this.onuKey+=1
         console.log(this.deviceDetail)

       })
    },
    async getServiceAccountDetails() {
      await Api()
        .get("/serviceAccounts/supplier/" + this.$route.params.serviceAccountId)
        .then(async response => {
          this.serviceAccount = response.data;
          if(response.data.deviceBridge){
            this.internetServices = [response.data.deviceBridge]
          }
          this.locationDevices = await this.fetchLocationDevices(this.serviceAccount.locationId)
          if(response.data.device.isU2000){
            // this.populateRequestTypes = ['Upgrade','Downgrade','Migration', 'Termination']
            this.populateRequestTypes = ['Upgrade','Downgrade', 'Termination']
          }else{
            this.populateRequestTypes = ['Upgrade','Downgrade', 'Termination']
          }
          this.maxDownload = response.data.packagesIsp.packagesFno.speedProfile.downloadMbps + 0.5*response.data.packagesIsp.packagesFno.speedProfile.downloadMbps
          this.maxUpload = response.data.packagesIsp.packagesFno.speedProfile.uploadMbps + 0.5*response.data.packagesIsp.packagesFno.speedProfile.uploadMbps
          if(this.serviceAccount.device.isU2000){
            //  this.deviceStatus(this.serviceAccount.device.ponMac)
             this.getU2000OnuStatus(this.serviceAccount.device)
              this.getU2000OnuDetails(this.serviceAccount.device)
          }
         
        });
    },
    async getServiceAccountHistory() {
      await Api()
        .get(
          "/serviceAccounts/allByIdentifier/" +
            this.serviceAccount.serviceAccountIdentifier
        )
        .then(response => {
          this.allServiceAccountHistory = response.data
          this.serviceAccountHistory = this.allServiceAccountHistory.slice(0,2);
        });
    },
    async getChangeRequests() {
      await Api()
        .get(
          "/serviceAccountsAuditLog/byServiceAccountId/" +
            this.$route.params.serviceAccountId
        )
        .then(response => {
          this.allPendingRequests = response.data.filter(
            x => x.status != "Denied" && x.status != "Resolved"
          );
          this.pendingRequests = this.allPendingRequests.slice(0,1);

          this.allResolvedRequests = response.data.filter(
            x => x.status == "Denied" || x.status == "Resolved"
          );
          this.resolvedRequests = this.allResolvedRequests.slice(0,1);
        });
    },
    async getWifiProfiles(){
      await Api().get('/deviceWifi/byDevice/'+this.serviceAccount.deviceId).then(res=>{
        this.wifiServices = res.data || []
      })
    },
    async getInternetProfiles(){
      await Api()
        .get("/deviceBridge/byBridge/" + this.serviceAccount.deviceBridgeId)
        .then(response => {
          // this.internetServices = response.data;
          // this.wifiServices = response.data.deviceWifis || []
          this.voipServices = response.data.deviceVoips || []
          if((this.wifiServices.length==0&&this.serviceAccount.device.deviceMakeModel.twoGhzWifi) ||(this.serviceAccount.device.deviceMakeModel.twoGhzWifi&& !this.wifiServices.map(x=>x.frequency).includes('2.4'))){
            this.availableFrequency.push('2.4')
          }
          if((this.wifiServices.length==0&&this.serviceAccount.device.deviceMakeModel.fiveGhzWifi)||(this.serviceAccount.device.deviceMakeModel.fiveGhzWifi && !this.wifiServices.map(x=>x.frequency).includes('5'))){
            this.availableFrequency.push('5')
          }
        });
    },
    async getTickets(){
      await Api().get('/ticket/byServiceAccount/'+this.$route.params.serviceAccountId)
      .then(response=>{
        this.allOpenTickets=response.data.filter(x=>!x.isComplete)
        this.allResolvedTickets=response.data.filter(x=>x.isComplete)
        this.pendingTickets = this.allOpenTickets.slice(0, 1);
        this.resolvedTickets = this.allResolvedTickets.slice(0, 1);
      })
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    formatDateTime(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
    terminatePreviousAccounts(){
      for(let k=0; k<this.terminatePreviousList.length; k++){
            Api().post('/serviceAccountsAuditLog', this.terminatePreviousList[k]) 
        .then(async response => {
          this.terminatePreviousList[k].serviceAccountAuditLogId = response.data.id;
          this.terminatePreviousList[k].ponMac = this.terminatePreviousList[k].device.ponMac
          this.terminatePreviousList[k].autoProvision = true;
          if(this.terminatePreviousList[k].device.acsDevice===true){
          this.terminatePreviousList[k].autoProvisionType = "ACS";
          this.terminatePreviousList[k].status= "Resolved",
          Api().put('/serviceAccountsAuditLog/'+ response.data.id, this.terminatePreviousList[k])
          }else if(this.terminatePreviousList[k].device.Handle_ID!==0 &&this.terminatePreviousList[k].device.Handle_ID!==null){
          this.terminatePreviousList[k].autoProvisionType = "Zhone";
          this.terminatePreviousList[k].status= "Resolved",
          this.terminatePreviousList[k].connectionId = this.terminatePreviousList[k].device.Handle_ID
          Api().put('/serviceAccountsAuditLog/'+ response.data.id, this.terminatePreviousList[k])
          }
         
        });
      }
     
    },
   terminateCurrentCreateNew(){
     let obj = {
        status: "Pending",
        serviceAccountId: this.$route.params.serviceAccountId,
        serviceAccountIdentifier: this.serviceAccount.serviceAccountIdentifier,
        locationId: this.serviceAccount.locationId,
        migrationLocationId: this.changeRequestItem.migrationLocation.id || null,
        packagesIspId: this.serviceAccount.packagesIspId,
        locationDescription: this.serviceAccount.location.locationDescription,
        customerOrganisationId: this.serviceAccount.packagesIsp
          .customerOrganisationId,
        ispName: this.serviceAccount.customerOrganisation.name,
        requestType: "Migration",
        isChange: this.serviceAccount.isChange,
        ispNotification: true,
        fnoNotification: true,
        ispContactName: null,
        fnoContactName:
          this.$store.state.user.name + " " + this.$store.state.user.surname,
        fromSpeedProfileName:
          this.serviceAccount.packagesIsp.packagesFno.speedProfile
            .downloadMbps +
          "/" +
          this.serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps,
        fromSpeedProfileId: this.serviceAccount.packagesIsp.packagesFno
          .speedProfileId,
        authenticationType: this.serviceAccount.authenticationType,
        pppoeUsername: this.serviceAccount.pppoeUsername || null,
        pppoePassword: this.serviceAccount.pppoePassword || null,
        IPoEMacAddress: this.serviceAccount.IPoEMacAddress || null,
        initialActivation: this.serviceAccount.initialActivation
          ? new Date(this.serviceAccount.initialActivation)
              .toISOString()
              .substr(0, 10)
          : null,
        fnoActivationDate: this.serviceAccount.fnoActivationDate
          ? new Date(this.serviceAccount.fnoActivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        fnoDeactivationDate: this.serviceAccount.fnoDeactivationDate
          ? new Date(this.serviceAccount.fnoDeactivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        ispActivationDate: this.serviceAccount.ispActivationDate
          ? new Date(this.serviceAccount.ispActivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        ispDeactivationDate: this.serviceAccount.ispDeactivationDate
          ? new Date(this.serviceAccount.ispDeactivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        requestedChangeDate: this.changeRequestItem.requestedChangeDate,
        staticIpv4: this.serviceAccount.staticIpv4 || null,
        staticIpv6: this.serviceAccount.staticIpv6 || null,
        deviceId: this.serviceAccount.deviceId,
        deviceBridgeId: this.serviceAccount.deviceBridgeId,        
        isDeleted: false,
        isActive: true
      }
       if(this.serviceAccount.deviceBridgeId){
              Api().get('/deviceBridge/byBridge/' + this.serviceAccount.deviceBridgeId).then(response=>{
          obj.vlan= response.data[0].vlan,
          obj.port_1= response.data[0].port_1,
          obj.port_2= response.data[0].port_2,
          obj.port_3= response.data[0].port_3,
          obj.port_4= response.data[0].port_4,
          obj.downstreamRate= response.data[0].downstreamRate,
          obj.upstreamRate= response.data[0].upstreamRate
              })
         
          }
         Api().post('/serviceAccountsAuditLog', obj) 
        .then(async response => {
          obj.serviceAccountAuditLogId = response.data.id;
          obj.ponMac = this.serviceAccount.device.ponMac           
          obj.autoProvision = true;
         
          obj.status= "Resolved",
          obj.deviceId =  this.serviceAccount.device.id,
          obj.accessType =  this.serviceAccount.authenticationType,
          obj.username =  this.serviceAccount.pppoeUsername,
          obj.password =  this.serviceAccount.pppoePassword,
          obj.customerOrganisationId =  this.serviceAccount.customerOrganisationId,
          obj.username =  this.serviceAccount.pppoeUsername,
         
          obj.ipv4or6= 'ipv4'
          obj.serviceAccountId = this.serviceAccount.id
          obj.locationId =  this.serviceAccount.locationId,         
          obj.serviceAccountIdentifier= this.serviceAccount.serviceAccountIdentifier,
          obj.migrationLocationId=this.changeRequestItem.migrationLocation.id,
          obj.packagesIspId= this.serviceAccount.packagesIspId,
          obj.locationDescription= this.serviceAccount.location.locationDescription,
           // customerOrganisationId: this.serviceAccount.packagesIsp.customerOrganisationId,
          obj.ispName= this.serviceAccount.customerOrganisation.name,
           //obj.serviceAccount.requestType: item.requestType,
        obj.isChange= this.serviceAccount.isChange,
        obj.ispNotification= true,
        obj.fnoNotification= true,
        obj.ispContactName= null,
        obj.fnoContactName=
          this.$store.state.user.name + " " + this.$store.state.user.surname,
        obj.fromSpeedProfileName=
          this.serviceAccount.packagesIsp.packagesFno.speedProfile
            .downloadMbps +
          "/" +
          this.serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps,
        obj.fromSpeedProfileId= this.serviceAccount.packagesIsp.packagesFno
          .speedProfileId,
        obj.IPoEMacAddress= this.serviceAccount.IPoEMacAddress || null,
        obj.initialActivation= this.serviceAccount.initialActivation
          ? new Date(this.serviceAccount.initialActivation)
              .toISOString()
              .substr(0, 10)
          : null,
        obj.fnoActivationDate= this.serviceAccount.fnoActivationDate
          ? new Date(this.serviceAccount.fnoActivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        obj.fnoDeactivationDate= this.serviceAccount.fnoDeactivationDate
          ? new Date(this.serviceAccount.fnoDeactivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        obj.ispActivationDate= this.serviceAccount.ispActivationDate
          ? new Date(this.serviceAccount.ispActivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        obj.ispDeactivationDate= this.serviceAccount.ispDeactivationDate
          ? new Date(this.serviceAccount.ispDeactivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        obj.staticIpv4= this.serviceAccount.staticIpv4 || null,
        obj.staticIpv6=this.serviceAccount.staticIpv6 || null,
        obj.deviceBridgeId= this.serviceAccount.deviceBridgeId,
        obj.isDeleted= false,
        obj.isActive= true
        if(this.serviceAccount.device.Handle_ID!==null&&this.serviceAccount.device.Handle_ID!==0){
           obj.autoProvisionType = "Zhone";
           obj.connectionId = this.serviceAccount.device.Handle_ID
        }else if(this.serviceAccount.device.acsDevice){
           obj.autoProvisionType = "ACS"
        }
          Api().put('/serviceAccountsAuditLog/'+ response.data.id, obj).then(response=>{
          
            this.getChangeRequests()
            this.getTickets()
            this.changeRequestModal = false;
          })
        });
   },
    logServiceAccountChange(item) {
      let toSpeedId = null;
      let toSpeedName = null;
      let toPackageId = null;
      let uploadMbps = 0
      let downloadMbps = 0

      if(item.requestType === "Migration"){
        this.terminatePreviousAccounts()
        this.terminateCurrentCreateNew()
      }
      if (
        item.requestType !== "Termination" &&
        item.requestType !== "Migration" &&
        item.toPackage
      ) {
        toSpeedId = item.toPackage.packagesFno.speedProfileId;
        toSpeedName =
          item.toPackage.packagesFno.speedProfile.downloadMbps +
          "/" +
          item.toPackage.packagesFno.speedProfile.uploadMbps;
        toPackageId = item.toPackage.id;
        uploadMbps = item.toPackage.packagesFno.speedProfile.uploadMbps
      downloadMbps = item.toPackage.packagesFno.speedProfile.downloadMbps
      }
      if (
        item.requestType !== "Migration"
      ) {
      let obj = {
        status: "Pending",
        serviceAccountId: this.$route.params.serviceAccountId,
        serviceAccountIdentifier: this.serviceAccount.serviceAccountIdentifier,
        locationId: this.serviceAccount.locationId,
        migrationLocationId: this.migrationLocationId || null,
        packagesIspId: this.serviceAccount.packagesIspId,
        locationDescription: this.serviceAccount.location.locationDescription,
        customerOrganisationId: this.serviceAccount.packagesIsp
          .customerOrganisationId,
        ispName: this.serviceAccount.customerOrganisation.name,
        requestType: item.requestType,
        isChange: this.serviceAccount.isChange,
        ispNotification: true,
        fnoNotification: true,
        ispContactName: null,
        fnoContactName:
          this.$store.state.user.name + " " + this.$store.state.user.surname,
        fromSpeedProfileName:
          this.serviceAccount.packagesIsp.packagesFno.speedProfile
            .downloadMbps +
          "/" +
          this.serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps,
        fromSpeedProfileId: this.serviceAccount.packagesIsp.packagesFno
          .speedProfileId,
        toSpeedProfileId: toSpeedId,
        toSpeedProfileName: toSpeedName,
        toPackageId: toPackageId,
        oldServiceAccountId: this.serviceAccount.id,
        authenticationType: this.serviceAccount.authenticationType,
        pppoeUsername: this.serviceAccount.pppoeUsername || null,
        pppoePassword: this.serviceAccount.pppoePassword || null,
        IPoEMacAddress: this.serviceAccount.IPoEMacAddress || null,
        initialActivation: this.serviceAccount.initialActivation
          ? new Date(this.serviceAccount.initialActivation)
              .toISOString()
              .substr(0, 10)
          : null,
        fnoActivationDate: this.serviceAccount.fnoActivationDate
          ? new Date(this.serviceAccount.fnoActivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        fnoDeactivationDate: this.serviceAccount.fnoDeactivationDate
          ? new Date(this.serviceAccount.fnoDeactivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        ispActivationDate: this.serviceAccount.ispActivationDate
          ? new Date(this.serviceAccount.ispActivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        ispDeactivationDate: this.serviceAccount.ispDeactivationDate
          ? new Date(this.serviceAccount.ispDeactivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        requestedChangeDate: item.requestedChangeDate,
        staticIpv4: this.serviceAccount.staticIpv4 || null,
        staticIpv6: this.serviceAccount.staticIpv6 || null,
        deviceId: this.serviceAccount.deviceId,
        deviceBridgeId: this.serviceAccount.deviceBridgeId,
        deviceBridge: this.serviceAccount.deviceBridge,
        device: this.serviceAccount.device,
        isDeleted: false,
        isActive: true,
        uploadMbps: uploadMbps,
        downloadMbps: downloadMbps
      };
      Api()
        .post("/serviceAccountsAuditLog", obj)
        .then(async response => {
          obj.serviceAccountAuditLogId = response.data.id;
          await this.acceptFNOChange(obj);
          this.changeRequestModal = false;
          this.changeRequestItem = {};
        });
      }
    },
    async acceptFNOChange(item) {
      let newServiceAccountId = null;
      if (this.authUpdate(this.$store.state.currentRoute)) {
        if (item.requestType !== "Termination") {
          let locationId = null;
          let deviceId = null;
          if (item.requestType !== "Migration") {
            locationId = item.locationId;
            deviceId = item.deviceId;
          } else {
            locationId = item.migrationLocationId;
            deviceId = null;
          }
          let requestedChangeDate = new Date(item.requestedChangeDate)
    requestedChangeDate.setDate(requestedChangeDate.getDate() - 1)
          Api().put("/serviceAccounts/" + this.$route.params.serviceAccountId, {
            ispDeactivationDate: requestedChangeDate,
            fnoDeactivationDate: requestedChangeDate
          });
          if (
            item.authenticationType === "PPPoE" ||
            item.authenticationType === "PPPOE"
          ) {
            item.IPoEActive = null;
          } else {
            item.IPoEActive = true;
          }

          let newAccount = {
            serviceAccountIdentifier: item.serviceAccountIdentifier.toString(),
              authenticationType: item.authenticationType,
              pppoeUsername: item.pppoeUsername || null,
              pppoePassword: item.pppoePassword || null,
              IPoEMacAddress: item.IPoEMacAddress,
              initialActivation: item.initialActivation,
              fnoActivationDate: item.requestedChangeDate || null,
              fnoDeactivationDate: null,
              ispActivationDate: item.requestedChangeDate || null,
              ispDeactivationDate: null,
              staticIpv4: item.staticIpv4 || null,
              staticIpv6: item.staticIpv6 || null,
              isChange: true,
              locationId: locationId,
              deviceId: deviceId,
              packagesIspId: item.toPackageId || item.packagesIspId,
              // vlanId: item.vlan.id,
              customerOrganisationId: item.customerOrganisationId,
              supplierOrganisationId: this.serviceAccount.supplierOrganisationId,
              organisationId: this.serviceAccount.organisationId,
              circuitNumber: this.serviceAccount.circuitNumber,
              deviceBridgeId: item.deviceBridgeId,
              deviceBridge: item.deviceBridge?item.deviceBridge:null,
              innerVlan: this.serviceAccount.innerVlan,
              outerVlan: this.serviceAccount.outerVlan,
              contactId: this.serviceAccount.contactId,
              IPoEActive: item.IPoEActive,
              isDeleted: false,
              isActive: true
          }

          await Api()
            .post("/serviceAccounts", newAccount)
            .then(response => {
              newServiceAccountId = response.data.id;
            });
        } else {
          Api().put("/serviceaccounts/" + this.$route.params.serviceAccountId, {
            fnoDeactivationDate: item.requestedChangeDate,
            ispDeactivationDate: item.requestedChangeDate
          });
        }

        let uploadMbps = 0;
        let downloadMbps = 0;
        if(item.uploadMbps){
          uploadMbps = item.uploadMbps
        }
        if(item.downloadMbps){
          downloadMbps = item.downloadMbps
        }
        if (item.toPackage && item.toPackage != null) {
          uploadMbps = item.toPackage.packagesFno.speedProfile.uploadMbps;
          downloadMbps = item.toPackage.packagesFno.speedProfile.downloadMbps;
        }
        let autoProvision = false;
        let autoProvisionType = null;
        let autoConfigure = false
        let autoConfigureType = null
        if (
          this.serviceAccount.device &&
          this.serviceAccount.device != null &&
          this.serviceAccount.device.Handle_ID != null &&
          !this.serviceAccount.device.isU2000
        ) {
          autoProvision = true;
          autoConfigure = true
          autoProvisionType = "Zhone";
          // autoConfigureType = 'Zhone'
        } else if(this.serviceAccount.device &&
          this.serviceAccount.device != null &&
          this.serviceAccount.device.isU2000){
            autoProvision = true;
            autoProvisionType = "U2000";
        }
        if (
          this.serviceAccount.device &&
          this.serviceAccount.device != null &&
          this.serviceAccount.device.acsDevice
        ) {
          autoConfigure = true
          autoConfigureType = 'ACS'
        }  else if(this.serviceAccount.authenticationType != 'Bridged'){
          autoConfigure = true
        }
        // debugger
        Api()
          .put("/serviceAccountsAuditLog/" + item.serviceAccountAuditLogId, {
            autoConfigure: autoConfigure,
            autoConfigureType: autoConfigureType,
            autoProvision: autoProvision,
            autoProvisionType: autoProvisionType,
            ponMac: this.serviceAccount.device.ponMac,
            customerOrganisationId: item.customerOrganisationId,
            fnoContactName:
              this.$store.state.user.name +
              " " +
              this.$store.state.user.surname,
            requestedChangeDate: item.requestedChangeDate,
            deviceId: item.deviceId,
            device: item.device,
            requestType: item.requestType,
            oldServiceAccountId: item.oldServiceAccountId,
            serviceAccountId: newServiceAccountId || this.serviceAccount.id,
            serviceAccount: this.serviceAccount,
            locationId: this.serviceAccount.locationId,
            connectionId: item.deviceBridge ? item.deviceBridge.connectionId : null,
            deviceBridgeId: item.deviceBridgeId,
            deviceBridge: item.deviceBridge?item.deviceBridge:null,
            deviceConfiguration: item.deviceConfiguration?item.deviceConfiguration:null,
            uploadMbps: uploadMbps,
            downloadMbps: downloadMbps,
            isActive: false,
            status: "Resolved",
            dateResolved: new Date()
          })
          .then(response => {
            this.snackbar=true
            this.text = "Successfully completed change request!"
            if(newServiceAccountId){
            this.$router.push({ path: "/serviceAccounts/"+ newServiceAccountId});
            } else {
            this.getChangeRequests()
            this.getTickets() 
            }
          });
      }
    },
    async fetchLocationDevices(id){
      let result = []
      await Api().get('/devices/byLocation/'+id).then(res=>{
        result = res.data.filter(x=>x.deviceMakeModel.deviceTypeId == 1)
      })
      return result
    },
    async fetchDeviceBridges(id){
      let result = []
      await Api().get('/deviceBridge/'+id).then(res=>{
        result = res.data
      })
      return result
    },
    async validateMigrationDetails(item){
      let locationDevices = await this.fetchLocationDevices(item.migrationLocationId)
      if(locationDevices.length==1&&locationDevices[0].deviceMakeModel.deviceMakeId === this.serviceAccount.device.deviceMakeModel.deviceMakeId){
        // handle one device: perfect match with make
        item.deviceId=locationDevices[0].id
        item.locationId = item.migrationLocationId
        let deviceBridges = await this.fetchDeviceBridges(item.deviceId)
        if(deviceBridges.length ==0){
          this.migrationErrorMessage = "No connections are currently listed against this device. Please ensure that the device has been configured before processing this request."
        this.migrationErrorModal = true
        } else {
          // let find = await deviceBridges.find(x=>x.vlanXlate === this.serviceAccount.deviceBridge.vlanXlate)
          if(this.serviceAccount.deviceBridge){
            item.deviceBridgeId = this.serviceAccount.deviceBridgeId
            this.processRequestChange(item)
        let obj = {
          description: 'Migrate services from '+this.serviceAccount.device.ponMac +' to ' + locationDevices[0].ponMac,
          ticketCategoryItemId: 56,
          currentStatus: 'Pending',
          importance: 'Average',
          dueDate: (new Date(item.requestedChangeDate)>new Date())?new Date(item.requestedChangeDate):new Date(),
          locationId: item.locationId,
          deviceId: item.deviceId,
          isActive: true,
          isDeleted: false
        }
        this.createConfigurationTicket(obj)
          } else {
            this.migrationErrorMessage = "Required VLAN not found on configured connections. Please add it before processing this request."
        this.migrationErrorModal = true
          }
          
        }
        
      } else if(locationDevices.length>1){
        // handle multiple devices
        this.migrationErrorMessage = "Multiple ONU's listed at new location. Please rectify before processing request."
        this.migrationErrorModal = true
      } else if(locationDevices.length==1){
        // Handle one device: makes don't match
        item.deviceId=locationDevices[0].id
        item.locationId = item.migrationLocationId
        this.processRequestChange(item)
        let obj = {
          description: 'Migrate services from '+this.serviceAccount.device.ponMac +' to ' + locationDevices[0].ponMac,
          ticketCategoryItemId: 56,
          currentStatus: 'Pending',
          importance: 'Average',
          dueDate: (new Date(item.requestedChangeDate)>new Date())?new Date(item.requestedChangeDate):new Date(),
          locationId: item.locationId,
          deviceId: item.deviceId,
          isActive: true,
          isDeleted: false
        }
        this.createConfigurationTicket(obj)
      } else {
        // Handle no devices
        this.migrationErrorMessage = "No ONU's listed at new location. Please rectify before processing request."
        this.migrationErrorModal = true
      }
      this.acceptingRequestChange=false
    },

    async createConfigurationTicket(obj){
      await Api().post("/ticket", obj).then(res=>{
        this.snackbar=true
        this.text="Successfully processed change request!"
      })
    },

   async acceptRequestChange(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){        
     this.acceptingRequestChange=true
      if (item.requestType !== "Termination") {
        if (item.requestType === "Migration") {
          await this.validateMigrationDetails(item)
        } else {
          this.processRequestChange(item)
        }
        
      } else {
        this.processRequestChange(item)
      //  await Api().put("/serviceaccounts/" + item.serviceAccountId, {
      //     fnoDeactivationDate: item.requestedChangeDate,
      //     ispDeactivationDate: item.requestedChangeDate
      //   }).then(res=>{
          

      //   });
      }

      
      }
    },

   async processRequestChange(item){
     let newServiceAccountId = this.serviceAccount.id;
     let requestedChangeDate = new Date(item.requestedChangeDate)
    requestedChangeDate.setDate(requestedChangeDate.getDate() - 1)
      await Api().put("/serviceAccounts/" + item.serviceAccountId, {
          ispDeactivationDate: requestedChangeDate,
          fnoDeactivationDate: requestedChangeDate
        });
        if (item.authenticationType === "PPPoE") {
          item.IPoEActive = null;
        } else {
          item.IPoEActive = true;
        }
        // let packagesIspId = null;
        // if (item.toSpeedProfileId === null) {
        //   packagesIspId = item.packagesIspId;
        // } else {
        //   packagesIspId = item.toPackageId;
        // }
        if (item.requestType !== "Termination") {
         await Api().post("/serviceAccounts", {
            serviceAccountIdentifier: item.serviceAccountIdentifier.toString(),
            authenticationType: item.authenticationType,
            pppoeUsername: item.pppoeUsername || null,
            pppoePassword: item.pppoePassword || null,
            IPoEMacAddress: item.IPoEMacAddress,
            initialActivation: item.initialActivation,
            fnoActivationDate: item.requestedChangeDate || null,
            fnoDeactivationDate: null,
            ispActivationDate: item.requestedChangeDate || null,
            ispDeactivationDate: null,
            staticIpv4: item.staticIpv4 || null,
            staticIpv6: item.staticIpv6 || null,
            isChange: true,
            locationId: item.locationId,
            customerOrganisationId: item.customerOrganisationId,
            supplierOrganisationId: this.serviceAccount.supplierOrganisationId,
            circuitNumber: item.requestType!="Migration"?this.serviceAccount.circuitNumber:null,
            organisationId: this.serviceAccount.organisationId,
            deviceBridgeId: item.requestType !== "Reactivation" ? this.serviceAccount.deviceBridgeId:null,
            innerVlan: this.serviceAccount.innerVlan,
            outerVlan: this.serviceAccount.outerVlan,
            contactId: this.serviceAccount.contactId,
            deviceId: item.deviceId,
            packagesIspId: item.toPackageId || item.packagesIspId,
            IPoEActive: item.IPoEActive,
            isDeleted: false,
            isActive: true
          }).then(response=>{
            newServiceAccountId = response.data.id
          });
        }

          let autoProvision = false;
        let autoProvisionType = null;
        let autoConfigure = false
        let autoConfigureType = null
        if (
          this.serviceAccount.device &&
          this.serviceAccount.device != null &&
          this.serviceAccount.device.Handle_ID != null &&
          !this.serviceAccount.device.isU2000
        ) {
          autoProvision = true;
          autoConfigure = true
          autoProvisionType = "Zhone";
          // autoConfigureType = 'Zhone'
        } else if(this.serviceAccount.device &&
          this.serviceAccount.device != null &&
          this.serviceAccount.device.isU2000){
            autoProvision = true;
            autoProvisionType = "U2000";
        }
        if (
          this.serviceAccount.device &&
          this.serviceAccount.device != null &&
          this.serviceAccount.device.acsDevice
        ) {
          autoConfigure = true
          autoConfigureType = 'ACS'
        } else if(this.serviceAccount.authenticationType != 'Bridged'){
          autoConfigure = true
        }
      
        let uploadMbps = 0
      let downloadMbps =0
      if(item.toSpeedProfile&&item.toSpeedProfile!=null){
        uploadMbps = item.toSpeedProfile.uploadMbps
        downloadMbps = item.toSpeedProfile.downloadMbps
      }
      if(item.requestType !== "Reactivation"){
 Api()
        .put("/serviceAccountsAuditLog/" + item.id, {
           autoConfigure: autoConfigure,
           autoConfigureType: autoConfigureType,
           autoProvision: autoProvision,
           autoProvisionType: autoProvisionType,
          ponMac: this.serviceAccount.device.ponMac,
          customerOrganisationId: item.customerOrganisationId,
          fnoContactName:
            this.$store.state.user.name + " " + this.$store.state.user.surname,
            requestedChangeDate: item.requestedChangeDate,
            deviceId: this.serviceAccount.deviceId,
            requestType: item.requestType,
            oldServiceAccountId: item.oldServiceAccountId,
            serviceAccountId: newServiceAccountId || this.$route.params.serviceAccountId,
            serviceAccount: this.serviceAccount,
            locationId: this.serviceAccount.locationId,
            connectionId: this.serviceAccount.deviceBridge ? this.serviceAccount.deviceBridge.connectionId : null,
            deviceBridgeId: this.serviceAccount.deviceBridgeId,
            deviceBridge: this.serviceAccount.deviceBridge,
            deviceConfiguration: this.serviceAccount.deviceConfiguration,
            device: this.serviceAccount.device,
            uploadMbps: uploadMbps,
            downloadMbps: downloadMbps,
          isActive: false,
          status: "Resolved",
          dateResolved: new Date()
          }).then(()=>{
            
            this.snackbar=true
            this.text = "Successfully completed change request!"
            if(newServiceAccountId != this.$route.params.serviceAccountId){
            this.$router.push({ path: "/serviceAccounts/"+ newServiceAccountId});
            } else {
            this.getChangeRequests()
            this.getTickets() 
            }

          });
      } else {
        let provisionTemplate = item.organisationBridgeTemplate
        provisionTemplate.downloadSpeed = item.fromSpeedProfile.downloadMbps
        provisionTemplate.uploadSpeed = item.fromSpeedProfile.uploadMbps
         Api()
        .put("/serviceAccountsAuditLog/" + item.id, {
           autoConfigure: autoConfigure,
           autoConfigureType: autoConfigureType,
           autoProvision: autoProvision,
           autoProvisionType: autoProvisionType,
           provisionTemplate: provisionTemplate,
          ponMac: this.serviceAccount.device.ponMac,
          device: item.device,
          customerOrganisationId: item.customerOrganisationId,
          fnoContactName:
            this.$store.state.user.name + " " + this.$store.state.user.surname,
            requestedChangeDate: item.requestedChangeDate,
            deviceId: this.serviceAccount.deviceId,
            requestType: item.requestType,
            oldServiceAccountId: item.oldServiceAccountId,
            serviceAccountId: newServiceAccountId || this.$route.params.serviceAccountId,
            serviceAccount: this.serviceAccount,
            locationId: this.serviceAccount.locationId,
            connectionId: this.serviceAccount.deviceBridge ? this.serviceAccount.deviceBridge.connectionId : null,
            deviceBridgeId: this.serviceAccount.deviceBridgeId,
            deviceBridge: this.serviceAccount.deviceBridge,
            deviceConfiguration: this.serviceAccount.deviceConfiguration,
            device: this.serviceAccount.device,
            uploadMbps: uploadMbps,
            downloadMbps: downloadMbps,
          isActive: false,
          status: "Resolved",
          dateResolved: new Date()
          }).then(()=>{
            
            this.snackbar=true
            this.text = "Successfully completed change request!"
            if(newServiceAccountId != this.$route.params.serviceAccountId){
            this.$router.push({ path: "/serviceAccounts/"+ newServiceAccountId});
            } else {
            this.getChangeRequests()
            this.getTickets() 
            }

          });
      }
     
        this.acceptingRequestChange=false
    },
    denyRequestChange(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
         this.denyingRequestChange=true
      Api()
        .put("/serviceAccountsAuditLog/" + item.id, {
          serviceAccountId: this.$route.params.serviceAccountId,
          fnoContactName: this.$store.state.user.name + " " + this.$store.state.user.surname,
          comment: this.denyReason,
          isActive: false,          
          customerOrganisationId: item.customerOrganisationId,
          status: "Denied"
        })
        .then(()=>{
          this.getChangeRequests()
          this.denyRequestModal=false
           this.denyingRequestChange=false
          this.denyReason = ''
        });
      }
    },
    async saveWifiProfile() {
      if (this.wifiItem.type === "ADD") {
        await Api()
          .post("/acs/createWifi", {
            ssid: this.wifiItem.ssid,
            password: this.wifiItem.password,
            channel: this.wifiItem.channel,
            encryption: this.wifiItem.encryption,
            enable: this.wifiItem.enable,
            hidden: this.wifiItem.hidden,
            frequency: this.wifiItem.frequencyBand,
            ponMac: this.serviceAccount.device.ponMac,
            customerOrganisationId: this.wifiItem.customerOrganisationId
          })
          .then(async response => {
              if(response.data.code===200){
                  await Api()
              .post("/deviceWifi", {
                ssid: this.wifiItem.ssid,
                password: this.wifiItem.password,
                channel: this.wifiItem.channel,
                encryption: this.wifiItem.encryption,
                enable: this.wifiItem.enable,
                hidden: this.wifiItem.hidden,
                frequencyBand: this.wifiItem.frequencyBand,
                deviceId: this.serviceAccount.deviceId,
                deviceBridgeId: this.serviceAccount.deviceBridgeId,
                customerOrganisationId: this.wifiItem.customerOrganisationId,
                isActive: true,
                isDeleted: false
              })
              .then(response => {
                this.wifiServices.push(response.data);
                this.snackbar = true
                this.text = response.data.message
              });
              } else {
                  this.errorSnackbar = true
                  this.text = response.data.message
              }
            this.wifiItem = {};
            this.addWifiProfileItem = false;
            let index = this.availableFrequency.find(x=>x==this.wifiItem.frequency)
            this.availableFrequency.splice(index, 1)
          });
      } else if (this.item.type === "EDIT") {
          await Api()
          .post("/acs/updateWifi", {
            ssid: this.wifiItem.ssid,
            password: this.wifiItem.password,
            channel: this.wifiItem.channel,
            encryption: this.wifiItem.encryption,
            enable: this.wifiItem.enable,
            hidden: this.wifiItem.hidden,
            frequency: this.wifiItem.frequencyBand,
            ponMac: this.device.ponMac,
            customerOrganisationId: this.item.customerOrganisationId
          }).then(response=>{
              Api()
          .put("/deviceWifi/" + this.wifiItem.id, {
            ssid: this.wifiItem.ssid,
            password: this.wifiItem.password,
            channel: this.wifiItem.channel,
            encryption: this.wifiItem.encryption,
            enable: this.wifiItem.enable,
            hidden: this.wifiItem.hidden,
            frequencyBand: this.wifiItem.frequencyBand,
            isActive: true,
            isDeleted: false
          })
          .then(async response => {
              let find = await this.item.deviceWifis.find(x=>x.id===this.wifiItem.id)
              if(find){
                  let index = this.item.deviceWifis.indexOf(find)
                  this.item.deviceWifis[index] = response.data
              }
            this.wifiItem = {};
            this.wifiKey += 1
            this.addWifiProfileItem = false;
          });
          })
        
      }
    },
  }
};
</script>
<style scoped>
.card-outter {
  position: relative;
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  bottom: 0;
  align-content: "center";
  justify-content: "center";
}
</style>